/** @format */

import {
	Component,
	OnInit,
	OnDestroy,
	TemplateRef,
	ViewChild,
	AfterViewInit,
	ElementRef,
	ChangeDetectionStrategy,
	Output,
	EventEmitter,
	AfterViewChecked,
	Input,
	ChangeDetectorRef,
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, Subscription, combineLatest, fromEvent, of, forkJoin, EMPTY } from 'rxjs';
import { delay, distinctUntilChanged, debounceTime, switchMap, catchError, first } from 'rxjs/operators';
import {
	UntypedFormGroup,
	UntypedFormControl,
	Validators,
	UntypedFormBuilder,
	UntypedFormArray,
	ValidatorFn,
	FormGroup,
	FormArray,
} from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModalRef, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';

import { Problem, NewProblem, ProblemContact, ContactPhone, DuplicateProblemPayload } from '../../models/problem';
import {
	MenuItem,
	GetProblems,
	initialProblem,
	SetProblemMarkers,
	getProblems,
	getMenus,
	getGalleryOptions,
	getNoPin,
	GetMenuOption,
	DashboardTabView,
	isDashboardTabView,
	getDashboardTabView,
	SetDashboardTabView,
	getActivities,
	GetActivities,
	AddActivity,
	SetNoMapLocation,
	ProblemType,
	SelectedProblemSubType,
	ProblemSource,
	getSelectedProblem,
	getAllUsers,
	ReassignProblem,
	UpdateProblem,
	ProblemStatus,
	GetDescriptionHistory,
	DelayedAction,
	getDescriptionHistory,
	getProblemContacts,
	UpdateActivity,
	ContactType,
	UpdateContact,
	getDnvSearchState,
	GetProblemAttachments,
	getProblemAttachments,
	UploadAttachments,
	DownloadEdocsFile,
	ActivityType,
	DeleteAttachment,
	UpdateAttachment,
	Group,
	GroupUser,
	AddProblemContacts,
	DeleteContact,
	DeletePhone,
	ProblemAssignment,
	getProblemAssignments,
	Role,
	getProblemRoleList,
	User,
	AddCodeCase,
	userFirstNameLastName,
	getGroupUsersList,
	GetNewCaseMenu,
	getNewCaseMenu,
	ProblemMenuConfig,
	SearchFromCoordinates,
	SearchCoordinatesPayload,
	getSearchCoordinate,
	CreatingCodeCase,
	getCreatingCodeCase,
	getGalleryImages,
	SetProblemAttachmentsImages,
	ProblemPriority,
	SetProblemAttachmentsImagesNull,
	SubmitWorkOrder,
	GetLayers,
	CheckLayerDisplay,
	getAsset,
	Asset,
	GetAsset,
	AddAsset,
	getInProgressActivity,
	SetInProgressActivity,
	DeleteWorkOrderByActivityId,
	AddWorkOrder,
	DelayedActionBy1,
	DeleteAsset,
	CancelActivity,
	getProblemNeighbors,
	GetProblemNeighbors,
	UpdateProblemRead,
	AddPermit,
	LinkedCase,
	getLinkedCases,
	AddProblemLinkedCase,
	GetProblemLinkedCases,
	UnlinkProblemCase,
	UpdateLinkedCasePayload,
	UpdateLinkedCaseNotes,
	UnlinkProblemCasePayload,
	FromProblemLinkedCasePayload,
	getLinkedCasesAddMenu,
	GetProblemLinkedCasesAddMenu,
	LinkedCaseRelated,
	getProblemNeighborScope,
	GetDashBoardProblems,
	getDashboardProblems,
	GetProblemLinkedCasesAddMenuSucccess,
	DownloadAzureFile,
	MessageToastOptions,
	ToastUserNotification,
	getMapState,
	getLayerState,
	DuplicateProblem,
	ProblemReceived,
	TransferringToCityworks,
	getTransferringToCityworks,
	CityworksTransferRequest,
	CityWorksRequestViewResponse,
	getRequestedCityworksView,
	CityworksRequestView,
	getIsGettingCityworksViewData,
	ClearCityworksRequestView,
	CityworksTransferMapping,
	getCityworksTransferMapping,
	GetCityworksTransferMap,
} from '../../state-management';

import {
	DnvMapState,
	CenterMap,
	SetZoom,
	DnvMapAction,
	DnvMarker,
	SetMarkers,
	SearchItem,
	initialSearchItem,
	DnvSearchState,
	DnvSearchService,
	SetSearchItemsUrl,
	DnvMapInfo,
	LayerState,
	SetActiveLayer,
	ZoomToFeatures,
	SetMapFeatureLayers,
	DnvFeatureLayer,
	AddFeatureLayers,
	RemoveFeatureLayers,
	SetShowDrawControl,
	SetMapShowFindMe,
	SetMapClusterView,
	PlainMapFunctionsOnly,
	UserNotification,
} from 'dnv-lib';

import { map, takeUntil, filter } from 'rxjs/operators';
import { NgxGalleryOptions, NgxGalleryImage } from '@vinlos/ngx-gallery';
import { Activity, ActivityList } from 'src/app/models/activity';
import { History } from 'src/app/models/history';
import { User as RapUser } from '../../state-management';
import { ConfigService } from '../../services/config.service';

import { AccountInfo as MsalUser } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';

import { LocationService, ProblemsService } from 'src/app/services';
import { Attachment, UploadAttachmentsPayload } from 'src/app/models/attachment';
import { buildMenu } from 'src/app/components';
import { environment } from 'src/environments/environment';
import { convertQuillToHTML } from 'src/app/utils/convertQuillToHTML';

import Quill from 'quill';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { b64toBlob } from 'src/app/utils/base64ToBlob';

const validatePhone: ValidatorFn = (fg: FormGroup) => {
	const phoneType = fg.get('phoneType').value;
	const phoneNum = fg.get('phoneNum').value;

	let isValid = true;
	if (phoneNum !== null && phoneNum !== '') {
		if (phoneType === null || phoneType === '') {
			isValid = false;
		}
	}

	if (phoneType !== null && phoneType !== '') {
		if (phoneNum === null || phoneNum === '') {
			isValid = false;
		}
	}

	return isValid ? null : { phoneInvalid: true };
};

@Component({
	selector: 'app-problem-detail',
	templateUrl: './problem-detail.component.html',
	styleUrls: ['./problem-detail.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ProblemDetailComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked, OnDestroy {
	@ViewChild('modalContact') modalContact: TemplateRef<any>;
	@ViewChild('modalReassign') modalReassign: TemplateRef<any>;
	@ViewChild('modalAddAsset') modalAddAsset: TemplateRef<any>;
	@ViewChild('modalDeleteAsset') modalDeleteAsset: TemplateRef<any>;
	// @ViewChild('modalDept') modalDept: TemplateRef<any>;
	@ViewChild('modalStatus') modalStatus: TemplateRef<any>;
	@ViewChild('modalLinkEG') modalLinkEG: TemplateRef<any>;
	@ViewChild('modalLinkRAP') modalLinkRAP: TemplateRef<any>;
	@ViewChild('modalEditLinkedCase') modalEditLinkedCase: TemplateRef<any>;
	@ViewChild('cancelActivityModal') cancelActivityModal: TemplateRef<any>;
	@ViewChild('removeDocumentModal') removeDocumentModal: TemplateRef<any>;
	@ViewChild('modalCityworksRequestView') modalCityworksRequestView: TemplateRef<any>;
	@ViewChild('unlinkCaseModal') unlinkCaseModal: TemplateRef<any>;
	@ViewChild('duplicateCaseModal') duplicateCaseModal: TemplateRef<any>;
	@ViewChild('zipFilesModal') zipFilesModal: TemplateRef<any>;

	@ViewChild('problemLocation') problemLocation: ElementRef;
	@ViewChild('locEditor') locEditor: ElementRef;
	@ViewChild('probCtrl') probCtrl: ElementRef;
	@ViewChild('problemType') probTypeSelect: ElementRef;

	// tslint:disable-next-line: no-output-on-prefix
	@Output() onSearchClick = new EventEmitter<SearchItem>();

	@Input() batchCaseProfilingNumber: string;
	@Input() shouldDestroyMap: boolean = false;

	private ngUnsubscribe: Subject<void> = new Subject();
	private readonly defaultIcon = 'far fa-question-circle';
	private selected: SearchItem = initialSearchItem;
	public search: (text$: Observable<string>) => Observable<SearchItem[]>;
	routeSubscription: Subscription = new Subscription();

	combinedLatest: Subscription = new Subscription();
	assetState$: Observable<Asset[]>;
	mapState$: Observable<DnvMapState>;
	layerState$: Observable<LayerState>;
	problems$: Observable<Problem[]>;
	problemNeighbors$: Observable<string[]>;
	problemNeighborScope$: Observable<string[]>;
	dashboardTabView$: Observable<string>;
	menuOption$: Observable<MenuItem>;
	galleryOptions$: Observable<NgxGalleryOptions[]>;
	galleryImages$: Observable<NgxGalleryImage[]>;
	galleryImages: NgxGalleryImage[] = [];
	currentUser: MsalUser; // 'User' from msal
	assignToMeUser: RapUser = null;
	problemDetail: Problem = initialProblem;
	activities$: Observable<ActivityList[]>;
	activities: ActivityList[] = [];
	selectedProblemType: ProblemType;

	noPin$: Observable<boolean>;
	selectedProblem$: Observable<string>;
	descriptionHistory$: Observable<History[]>;
	allUsers$: Observable<RapUser[]>; // TODO place users in a Map in the store... new Map(arr.map(obj => [obj.key, obj]));
	groupUsers$: Observable<GroupUser[]>;
	roles: Role[];
	scrollObservable$: Observable<Event>;
	scrollSubscription: Subscription = new Subscription();
	clickObservable$: Observable<MouseEvent>;
	clickSubscription: Subscription = new Subscription();

	titleText: string;

	problemContacts$: Observable<ProblemContact[]>;
	problemContacts: ProblemContact[];
	problemNo: string;
	galleryOptions: NgxGalleryOptions[];
	reassignForm: UntypedFormGroup;
	closeProblemForm: UntypedFormGroup;
	linkEGForm: UntypedFormGroup;
	linkedCaseEditForm: UntypedFormGroup;
	linkRAPForm: UntypedFormGroup;
	duplicateCaseForm: UntypedFormGroup;
	modal: NgbModalRef = null;
	assignedTo = '';
	assignedToUser: RapUser = null; // the user that correspond to this.problemDetails.assignedTo
	filteredGroupUser: RapUser[]; // 'User' from application.state
	groupList: Group[];
	filteredProblemTypes: ProblemType[];
	filteredProblemSubTypes: SelectedProblemSubType[] = [];

	problemSourceList: ProblemSource[];
	problemReceivedList: ProblemReceived[];

	problemPriorityList: ProblemPriority[];
	problemStatusList: ProblemStatus[];
	allProblemTypes: ProblemType[];
	allProblemSubTypes: SelectedProblemSubType[];
	contactTypes: ContactType[];
	activeContactTypesList: ContactType[];
	activityTypes: ActivityType[];
	currentSection = 'overview';
	sidebarClick = false;
	isMyGroup = false;
	hideHistory = true;
	quillEditForm: UntypedFormGroup;
	locFocus = false;
	quillDescFocus = false;
	quillDescEditor: Quill;
	dnvSearchState$: Observable<DnvSearchState>;
	dnvSearchState: DnvSearchState;
	undoEdit = false;
	newStatus: string;
	editContactForm: UntypedFormGroup;
	contactFormTitle = 'Add ';
	deletePhones: number[] = [];
	problemAssignments$: Observable<ProblemAssignment[]>;
	problemAssignments: ProblemAssignment[] = [];
	fragment: string;
	problemRoleList$: Observable<Role[]>;
	problemRoleList: Role[];
	fragmentSubscription: Subscription;
	lastUpdatedByName: string;
	linkedCaseList$: Observable<LinkedCase[]>;
	linkedCaseList: LinkedCase[] = [];

	problemDashboard$: Observable<string[]>;
	addLinkLinkedCaseList$: Observable<LinkedCaseRelated>; // List of linked case inside Link a Problem Menu
	addLinkLinkedCaseList: LinkedCaseRelated;

	attachments$: Observable<Attachment[]>;
	attachments: Attachment[] = [];
	attachmentImageCount = 1;
	galleryReady = false;
	filteredUsersByGroup: RapUser[];
	newCaseMenu$: Observable<ProblemMenuConfig[]>;
	filteredProbTypes: ProblemType[];
	problemTypeMenu: any;
	message = '';
	selectedMenuOne: string;
	selectedMenuTwo: string;
	menuConfig: ProblemMenuConfig[];
	mappedUsers: any[] = [];
	groupedMappedUsers: any[] = [];
	groupUsers: any[] = [];
	searchCoordinate$: Observable<SearchCoordinatesPayload>;
	searchCoordinate: SearchCoordinatesPayload;
	mapState: DnvMapState;
	showAssignChange = false;
	assignChangeMsg = '';
	showProbTypeDropdown = false;
	creatingCodeCase$: Observable<boolean>;

	inProgressActivity$: Observable<boolean>;
	inProgressActivityText$: Observable<string>;
	menuOption: MenuItem;
	layerState: LayerState;
	assetState: Asset[];
	assetId: string;
	assetUId: string;
	assetToDelete: Asset;
	showAsset: boolean;
	activityToCancel: ActivityList;
	attachmentToRemove: Attachment;
	linkedCaseToRemove: LinkedCase;
	linkedCaseToEdit: LinkedCase;
	nextProblem = '';
	previousProblem = '';
	isPermit = false;
	egSearch: (text$: Observable<string>) => Observable<string[]>;
	egNumber = '';
	linkNotesText = '';
	rapSearch: (text$: Observable<string>) => Observable<string[]>;
	rapNumber = '';
	dbRapNumber = '';
	sharedSearchRapNumber = '';
	linkingLabel = '';
	relatedOptionsLabel = '';

	contactsExtracted = false;
	activitiesExtracted = false;
	linkedCasesExtracted = false;
	attachmentsExtracted = false;
	getAttachmentsCalled = false;
	mapLayerLoaded = false;
	isBatchExport = false;
	selectedPriority: string;

	shouldZipAllFiles: boolean = false;
	hasZipFilesError: boolean = false;
	activeGroupsList: Group[];

	cityworksTransferMapping$: Observable<CityworksTransferMapping[]>;
	transferringToCityworks$: Observable<boolean>;
	requestedCityworksView$: Observable<CityWorksRequestViewResponse>;
	requestedCityworksView: CityWorksRequestViewResponse;
	requestedCityworksViewPhotoUrls: string[] = [];
	requestedCityworksViewNgxGallery: NgxGalleryImage[] = [];

	requestedCityworksViewId: number;
	isGettingCityworksViewData$: Observable<boolean>;
	isGettingCityworksViewData: boolean = false;
	isCityworksRequest = false;
	isCityworksTransferrable = false;

	// Format the autosuggested item into a string for the input control
	formatter = (x: { name: string }) => x.name;
	selectedProblemSubType: SelectedProblemSubType;

	constructor(
		private store: Store<{}>,
		private route: ActivatedRoute,
		private authService: MsalService,
		private modalService: NgbModal,
		private activeModal: NgbActiveModal,
		private locationService: LocationService,
		private configService: ConfigService,
		private formBuilder: UntypedFormBuilder,
		private location: Location,
		private router: Router,
		private problemsService: ProblemsService,
		private changeDetector: ChangeDetectorRef,
	) {
		this.currentUser = this.authService.instance.getActiveAccount();
		this.assetState$ = this.store.select(getAsset).pipe(takeUntil(this.ngUnsubscribe));
		this.mapState$ = this.store.select(getMapState).pipe(takeUntil(this.ngUnsubscribe));
		this.problems$ = this.store.select(getProblems).pipe(takeUntil(this.ngUnsubscribe));
		this.problemNeighbors$ = this.store.select(getProblemNeighbors).pipe(takeUntil(this.ngUnsubscribe));
		this.problemNeighborScope$ = this.store.select(getProblemNeighborScope).pipe(takeUntil(this.ngUnsubscribe));
		this.menuOption$ = this.store.select(getMenus).pipe(takeUntil(this.ngUnsubscribe));
		this.galleryOptions$ = this.store.select(getGalleryOptions).pipe(takeUntil(this.ngUnsubscribe));
		this.dashboardTabView$ = this.store.select(getDashboardTabView).pipe(takeUntil(this.ngUnsubscribe));
		this.activities$ = this.store.select(getActivities).pipe(takeUntil(this.ngUnsubscribe));
		this.noPin$ = this.store.select(getNoPin).pipe(takeUntil(this.ngUnsubscribe));
		this.selectedProblem$ = this.store.select(getSelectedProblem).pipe(takeUntil(this.ngUnsubscribe));
		this.layerState$ = this.store.select(getLayerState).pipe(takeUntil(this.ngUnsubscribe));
		this.allUsers$ = this.store.select(getAllUsers).pipe(takeUntil(this.ngUnsubscribe));
		this.groupUsers$ = this.store.select(getGroupUsersList).pipe(takeUntil(this.ngUnsubscribe));
		this.descriptionHistory$ = this.store.select(getDescriptionHistory).pipe(takeUntil(this.ngUnsubscribe));
		this.problemContacts$ = this.store.select(getProblemContacts).pipe(takeUntil(this.ngUnsubscribe));
		this.dnvSearchState$ = this.store.select(getDnvSearchState).pipe(takeUntil(this.ngUnsubscribe));
		this.attachments$ = this.store.select(getProblemAttachments).pipe(takeUntil(this.ngUnsubscribe));
		this.problemAssignments$ = this.store.select(getProblemAssignments).pipe(takeUntil(this.ngUnsubscribe));
		this.problemRoleList$ = this.store.select(getProblemRoleList).pipe(takeUntil(this.ngUnsubscribe));
		this.newCaseMenu$ = this.store.select(getNewCaseMenu).pipe(takeUntil(this.ngUnsubscribe));
		this.searchCoordinate$ = this.store.select(getSearchCoordinate).pipe(takeUntil(this.ngUnsubscribe));
		this.transferringToCityworks$ = this.store.select(getTransferringToCityworks).pipe(takeUntil(this.ngUnsubscribe));
		this.requestedCityworksView$ = this.store.select(getRequestedCityworksView).pipe(takeUntil(this.ngUnsubscribe));
		this.isGettingCityworksViewData$ = this.store.select(getIsGettingCityworksViewData).pipe(takeUntil(this.ngUnsubscribe));
		this.creatingCodeCase$ = this.store.select(getCreatingCodeCase).pipe(takeUntil(this.ngUnsubscribe));
		this.inProgressActivity$ = this.store.select(getInProgressActivity).pipe(takeUntil(this.ngUnsubscribe));
		this.galleryImages$ = this.store.select(getGalleryImages).pipe(takeUntil(this.ngUnsubscribe));
		this.linkedCaseList$ = this.store.select(getLinkedCases).pipe(takeUntil(this.ngUnsubscribe));
		this.addLinkLinkedCaseList$ = this.store.select(getLinkedCasesAddMenu).pipe(takeUntil(this.ngUnsubscribe));
		this.problemDashboard$ = this.store.select(getDashboardProblems).pipe(takeUntil(this.ngUnsubscribe));
		this.cityworksTransferMapping$ = this.store.select(getCityworksTransferMapping).pipe(takeUntil(this.ngUnsubscribe));

		window.addEventListener('mapLayerLoaded', () => {
			// wait for 1 second to allow the map to finish rendering the tiles
			setTimeout(() => (this.mapLayerLoaded = true), 5000);
		});
	}

	ngOnInit() {
		if (this.batchCaseProfilingNumber) {
			this.isBatchExport = true;
			this.waitUntilReadyToExport();
		}

		this.store.dispatch(new GetCityworksTransferMap());
		this.store.dispatch(new SetMapClusterView(false));
		this.store.dispatch(new SetMapShowFindMe(true));
		this.store.dispatch(new PlainMapFunctionsOnly(true));
		this.store.dispatch(new SetProblemAttachmentsImagesNull());
		// this.store.dispatch(new SetSearchItemsUrl(`${environment.searchApiEndpointUrl}api/`));
		this.store.dispatch(new SetShowDrawControl(false));
		this.store.dispatch(new GetAsset());
		this.store.dispatch(new GetLayers());

		this.dnvSearchState$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((searchState) => {
			this.dnvSearchState = searchState;
		});

		this.assetState$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((assetState) => {
			if (assetState.length > 0) {
				this.assetState = assetState;
			}
		});

		this.layerState$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((layerState: LayerState) => {
			if (layerState.layers.length > 0) {
				this.layerState = layerState;
			}
		});

		this.activities$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((activities) => {
			this.activitiesExtracted = true;
			this.activities = activities;
		});

		this.linkedCaseList$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((linkedCaseList) => {
			this.linkedCasesExtracted = true;
			this.linkedCaseList = linkedCaseList;
		});

		this.attachments$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((attachments) => (this.attachments = attachments));
		this.galleryImages$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((galleryImages) => {
			this.galleryImages = galleryImages;
		});

		this.requestedCityworksView$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((requestedCityworksView) => {
			this.requestedCityworksView = requestedCityworksView;
			this.requestedCityworksViewPhotoUrls = [];
			this.requestedCityworksViewNgxGallery = [];

			requestedCityworksView.images.forEach((image) => {
				const blob = window.URL.createObjectURL(b64toBlob(image.fileData, image.fileType.toLowerCase(), 512));
				this.requestedCityworksViewNgxGallery.push({
					small: blob,
					medium: blob,
					big: blob,
					description: 'Cityworks Image',
					label: image.fileName,
				});
			});
		});

		this.isGettingCityworksViewData$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((isGettingCityworksViewData) => {
			this.isGettingCityworksViewData = isGettingCityworksViewData;
			if (!isGettingCityworksViewData) {
				if (
					this.requestedCityworksView?.description === '' &&
					this.requestedCityworksView?.details === '' &&
					this.requestedCityworksView?.status === ''
				) {
					this.closeCityworksView();
				}
			}
		});

		this.egSearch = (text$: Observable<string>): Observable<string[]> => {
			return text$.pipe(
				debounceTime(50),
				distinctUntilChanged(),
				switchMap((name: string) => {
					// const currentSearchUrl = this.dnvSearchState.searchItemsUrl + 'v1/permitplannumbersearch/autosuggest/' + name;
					if (name.length > 0) {
						return this.locationService.getSearchItems('api/gis/egSearchItems/' + name).pipe(
							catchError(
								(error: HttpErrorResponse): Observable<string[]> => {
									return of([]);
								},
							),
						);
					} else {
						return EMPTY;
					}
				}),
				map((itemsMap: string[]) => {
					return itemsMap;
				}),
			);
		};

		this.rapSearch = (text$: Observable<string>): Observable<string[]> => {
			return text$.pipe(
				debounceTime(50),
				distinctUntilChanged(),
				switchMap((name: string) => {
					const currentSearchUrl = '/api/problemlinked/autosuggest/' + name;
					if (name.length > 0) {
						return this.locationService.getPermitItems(currentSearchUrl).pipe(
							catchError(
								(error: HttpErrorResponse): Observable<string[]> => {
									return of([]);
								},
							),
						);
					} else {
						return EMPTY;
					}
				}),
				map((itemsMap: string[]) => {
					return itemsMap;
				}),
			);
		};

		this.search = (text$: Observable<string>): Observable<SearchItem[]> => {
			return text$.pipe(
				debounceTime(50),
				distinctUntilChanged(),
				switchMap((name: string) => {
					// const currentSearchUrl = this.dnvSearchState.searchItemsUrl + 'searchitems/' + name;

					return forkJoin({
						searchItems: this.locationService.getSearchItems('api/gis/searchapp/' + name).pipe(
							catchError(
								(error: HttpErrorResponse): Observable<SearchItem[]> => {
									return of([]);
								},
							),
						),
						intersections: this.locationService.getSearchItems('api/gis/searchitems/' + name).pipe(
							catchError(
								(error: HttpErrorResponse): Observable<SearchItem[]> => {
									return of([]);
								},
							),
						),
					});
				}),
				map((itemsMap) => {
					// Filter out the duplicate entries in the search suggestions that point to the same location
					itemsMap.intersections = itemsMap.intersections.filter(
						(intersection, index, self) =>
							index ===
							self.findIndex(
								(cmpIntersection) => cmpIntersection.name === intersection.name && cmpIntersection.type === intersection.type,
							),
					);

					return [...itemsMap.searchItems, ...itemsMap.intersections];
				}),
				// switchMap((name: string) => {
				//   const currentSearchUrl = this.dnvSearchState.searchItemsUrl + '/' + name;
				//   return this.locationService.getSearchItems(currentSearchUrl)
				//     .pipe(
				//       catchError((error: HttpErrorResponse): Observable<SearchItem[]> => {
				//         return of([]);
				//       }),
				//     );
				// })
			);
		};

		this.addLinkLinkedCaseList$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((linkedCaseRelated) => {
			this.addLinkLinkedCaseList = linkedCaseRelated;

			if (this.addLinkLinkedCaseList.linkPossibility === 'None') {
				this.linkRAPForm.get('relatedLink').setValue(null);
			} else if (this.addLinkLinkedCaseList.linkPossibility === 'None-LinkExists') {
				this.linkRAPForm.get('relatedLink').setValue(null);
			} else if (this.addLinkLinkedCaseList.linkPossibility === 'LinkOnly') {
				this.linkRAPForm.get('relatedLink').setValue('link');
			} else if (this.problemDetail.linkedStatus === 'Parent') {
				this.linkingLabel = 'The problem you are linking from is a';
				this.relatedOptionsLabel = "Link problems + use the same Parent for the problem I'm linking";
			} else if (this.problemDetail.linkedStatus === 'Child') {
				this.linkingLabel = 'The problem you are linking from has a';
				this.relatedOptionsLabel = "Link problems + use the same Parent for the problem I'm linking";
			} else if (this.addLinkLinkedCaseList.linkPossibility === 'ParentAssign|Link') {
				this.linkRAPForm.get('parentNumber').setValue(this.addLinkLinkedCaseList.linkedCases[0].problemNumber);
			} else {
				if (this.addLinkLinkedCaseList.parentNumber === this.rapNumber || this.addLinkLinkedCaseList.parentNumber === this.dbRapNumber) {
					this.linkingLabel = 'The problem you want to link is a';
					this.relatedOptionsLabel = "Link problems + make this the Parent of the problem I'm linking from";
				} else {
					this.linkingLabel = 'The problem you want to link has a';
					this.relatedOptionsLabel = "Link problems + make this the Parent of the problem I'm linking from";
				}
			}

			if (
				this.addLinkLinkedCaseList.linkPossibility !== null &&
				this.addLinkLinkedCaseList.linkPossibility !== 'None' &&
				this.addLinkLinkedCaseList.linkPossibility !== 'LinkOnly' &&
				this.addLinkLinkedCaseList.linkPossibility !== 'None-LinkExists'
			) {
				this.linkRAPForm.get('relatedLink').setValue('related');
			}
		});

		this.attachments$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((attachments: Attachment[]) => {
			const imageTypes: string[] = ['gif', 'jpg', 'jpeg', 'png'];
			const imageCount = attachments.filter((a) => imageTypes.includes(a.fileType.toLowerCase())).length;
			if (imageCount === 0) {
				this.store.dispatch(new SetProblemAttachmentsImages([]));
			}

			this.attachmentImageCount = imageCount;
			this.attachmentsExtracted = this.getAttachmentsCalled && true;
		});

		this.routeSubscription = this.route.queryParams.pipe(filter((params) => params.ProblemNo)).subscribe((params) => {
			if (params.AssetId) {
				this.assetId = params.AssetId;
				this.assetUId = params.UId;
			}

			this.problemNo = params.ProblemNo;
			this.titleText = document.getElementsByTagName('title')[0].text;
			document.getElementsByTagName('title')[0].text = `RAP - ${this.problemNo}`;

			this.store.dispatch(new GetMenuOption());
			this.store.dispatch(new GetProblems({ problemNo: this.problemNo }));
			this.store.dispatch(new GetProblemNeighbors({ problemNo: this.problemNo }));
			this.store.dispatch(new GetActivities(this.problemNo));
			// this.store.dispatch(new GetProblemHistory(this.problemNo));
			this.store.dispatch(new GetProblemAttachments(this.problemNo));
			this.store.dispatch(new UpdateProblemRead(params.ProblemNo));
		});

		if (this.batchCaseProfilingNumber) {
			this.problemNo = this.batchCaseProfilingNumber;
			this.store.dispatch(new GetMenuOption());
			this.store.dispatch(new GetProblems({ problemNo: this.problemNo }));
			this.store.dispatch(new GetProblemNeighbors({ problemNo: this.problemNo }));
			this.store.dispatch(new GetActivities(this.problemNo));
			this.store.dispatch(new GetProblemAttachments(this.problemNo));
			this.getAttachmentsCalled = true;
		}

		this.store.dispatch(new SetDashboardTabView('overview'));
		this.store.dispatch(new GetNewCaseMenu());

		this.quillEditForm = new UntypedFormGroup({
			locEditor: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
			descEditor: new UntypedFormControl('', [Validators.required]),
		});

		this.problemNeighbors$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
			const neighborProblems: string[] = data;
			if (neighborProblems.length > 0) {
				this.nextProblem = neighborProblems[0].length > 0 ? neighborProblems[0] : '';
				this.previousProblem = neighborProblems[1].length > 0 ? neighborProblems[1] : '';
			}
		});

		this.combinedLatest = combineLatest([this.problems$, this.menuOption$, this.cityworksTransferMapping$])
			.pipe(
				// Temp fix on a race condition on line 227, quillDescEditor. Possibly not initilized before combinelatest.
				delay(200),
				takeUntil(this.ngUnsubscribe),
			)
			.subscribe(([problemsOb, menuOptionOb, transferMappingOb]) => {
				const targetProblem = problemsOb.filter((p) => p.problemNo === this.problemNo);
				if (targetProblem.length > 0 && menuOptionOb.problemGroupList.length > 0) {
					this.problemDetail = targetProblem[0];
					this.selectedPriority = targetProblem[0].priority;

					this.isCityworksRequest = this.problemDetail.assignedTo.trim().toLowerCase() === 'cityworks';
					this.isCityworksTransferrable = transferMappingOb.some(
						(mapping) =>
							mapping.group_RefId === this.problemDetail.group_RefId &&
							mapping.problemType_RefId === this.problemDetail.problemType_RefId,
					);

					this.store.dispatch(
						new GetProblemLinkedCases({
							linkedStatus: this.problemDetail.linkedStatus,
							caseNo: this.problemNo,
						}),
					);

					this.showAsset = this.problemDetail.group_RefId === 7 || this.problemDetail.group_RefId === 12;

					// Load Asset
					if (this.assetState && this.assetState.length > 0 && this.layerState && this.layerState.layers.length > 0) {
						const dbAsset = this.assetState.filter((a) => a.problem_RefId === this.problemDetail.problemId);

						if (this.assetId && this.assetUId && !dbAsset.find((a) => a.gisAssetId === this.assetId)) {
							this.open(this.modalAddAsset);

							// Exception - RAP service feature layers contain multiple assets within SAN_FITTING and SAN_SERVICE_CONN
							if (this.assetUId === 'SAN_SERVICE_CONN_CAP') {
								this.assetUId = 'SAN_SERVICE_CONN';
							} else if (this.assetUId === 'WTR_SERVICE_CONN_CAP') {
								this.assetUId = 'WTR_SERVICE_CONN';
							} else if (this.assetUId === 'STMN_SERVICE_CONN_CAP') {
								this.assetUId = 'STMN_CONN';
							} else if (this.assetUId === 'SAN_INSPECTION_CHAMBERS' || this.assetUId === 'SAN_DNV_MANHOLES') {
								this.assetUId = 'SAN_FITTING';
							}

							const layer = this.layerState.layers.find((l: any) => l.featureLayers[0].uId === this.assetUId);

							if (layer) {
								layer.featureLayers[0].whereClause = "Asset_Id IN ('" + this.assetId + "')";

								// this.store.dispatch(new ZoomToFeatures(layer.featureLayers));
								this.store.dispatch(new SetActiveLayer(layer));
								this.store.dispatch(new CheckLayerDisplay());
							}
						}

						if (dbAsset && dbAsset.length > 0) {
							const assetIds = dbAsset.reduce((r: any, a: any) => {
								// console.log("a", a || 'empty');
								// console.log('r', r || 'empty');
								r[a.featureLayer_UId] = [...(r[a.featureLayer_UId] || []), a.gisAssetId];
								return r;
							}, []);

							this.layerState.layers.forEach((l: any) => {
								if (assetIds[l.featureLayers[0].uId] && assetIds[l.featureLayers[0].uId].length > 0) {
									let asset_Id = '';
									assetIds[l.featureLayers[0].uId].forEach((a: string) => {
										asset_Id += "'" + a + "',";
									});

									if (asset_Id) {
										if (l.featureLayers[0].whereClause.indexOf('Asset_Id') > -1) {
											l.featureLayers[0].whereClause =
												l.featureLayers[0].whereClause.slice(0, -1) + ',' + asset_Id.slice(0, -1) + ')';
										} else {
											l.featureLayers[0].whereClause = 'Asset_Id in (' + asset_Id.slice(0, -1) + ')';
										}

										// TODO: setView method inside esri-leaflet library bugs out when loading a problem with assets
										// from another problem with a different location. Seems like loading assets while it's zooming into
										// another part of the map creates a conflict within the virtual grid addcells method. Added a delay
										// to let the app finish zoom in before loading the assets.
										this.store.dispatch(new DelayedActionBy1([new SetActiveLayer(l), new CheckLayerDisplay()]));
									}
								}
							});
						}
					}

					this.menuOption = menuOptionOb;
					// set user/role dropdown in reassign user form
					if (this.problemDetail.assignedTo !== null && this.problemDetail.assignedTo.length > 0) {
						const usr = menuOptionOb.allUsersList.find((u) => u.firstName + ' ' + u.lastName === this.problemDetail.assignedTo);
						this.reassignForm.get('userName').setValue(usr);
					} else if (this.problemDetail.problemRole !== null) {
						const rle = menuOptionOb.problemRoleList.find((r) => r.name === this.problemDetail.problemRole);
						this.reassignForm.get('userName').setValue(rle);
					} else {
						this.reassignForm.get('userName').setValue(0); // unassigned = 0
					}

					if (this.quillDescEditor) {
						var description = this.problemDetail.problemDescription.replaceAll('<br>', '\n').replaceAll('</br>', '\n');

						if (
							description.includes('<ul>') ||
							description.includes('<ol>') ||
							description.includes('<p>') ||
							description.includes('<li>')
						) {
							const delta = this.quillDescEditor.clipboard.convert({ text: description });
							this.quillDescEditor.setContents(delta, 'silent');
						} else {
							this.quillDescEditor.setText(description.trim());
						}
					}

					if (this.problemDetail.latLng.lat === 0 && this.problemDetail.latLng.lng === 0) {
						this.store.dispatch(new SetNoMapLocation(true));
					} else {
						this.store.dispatch(new SetNoMapLocation(false));
						this.store.dispatch(new DelayedAction([new CenterMap(this.problemDetail.latLng), new SetZoom(Number(5))]));
					}

					this.assignedTo = this.problemDetail.assignedTo;

					this.store.dispatch(new SetProblemMarkers({ problem: [this.problemDetail], showToolTip: false }));

					this.assignedToUser = menuOptionOb.allUsersList.find((u) => u.firstName + ' ' + u.lastName === this.assignedTo) || null;
					this.assignToMeUser = menuOptionOb.allUsersList.find((u) => u.upn.toLowerCase() === this.currentUser.username.toLowerCase()); // TODO confirm userName

					this.filteredGroupUser = menuOptionOb.allUsersList.filter(
						(u) => this.findAllGroupUser(menuOptionOb).findIndex((gU) => gU.user_RefId === u.user_Id) > -1,
					);

					this.groupList = menuOptionOb.problemGroupList;
					this.activeGroupsList = menuOptionOb.problemGroupList.filter((g) => g.active);

					this.problemSourceList = menuOptionOb.problemSourceList;
					this.problemReceivedList = menuOptionOb.problemReceivedFromList;
					this.problemStatusList = menuOptionOb.problemStatusList;
					this.allProblemTypes = menuOptionOb.allProblemTypeList;
					this.allProblemSubTypes = menuOptionOb.allProblemSubTypeList;
					this.problemPriorityList = menuOptionOb.problemPriorityList;
					this.activityTypes = menuOptionOb.activityTypeList;

					const problemAssignmentsForCurrentGroup = menuOptionOb.problemAssignments.filter(
						(pa) => pa.group_RefId === this.problemDetail.group_RefId,
					);

					this.filteredProblemTypes = this.allProblemTypes.filter(
						(p) => problemAssignmentsForCurrentGroup.findIndex((pa) => pa.problemType_RefId === p.problemType_Id) > -1,
					);

					this.selectedProblemType = (this.allProblemTypes as any).filter(
						(p: ProblemType) => p.problemType_Id === this.problemDetail.problemType_RefId,
					)[0];

					if (!this.filteredProblemTypes.find((pt) => pt.problemType_Id === this.problemDetail.problemType_RefId)) {
						this.filteredProblemTypes.push(this.allProblemTypes.find((pt) => pt.problemType_Id === this.problemDetail.problemType_RefId));
					}

					this.filteredProblemSubTypes = this.allProblemSubTypes?.filter(
						(pst) => pst.problemType_RefId === this.problemDetail.problemType_RefId,
					);

					this.selectedProblemSubType = this.filteredProblemSubTypes.filter(
						(st) => st.problemSubType_Id === this.problemDetail.problemSubType_RefId,
					)[0];

					if (!this.isBatchExport) {
						if (this.filteredProblemSubTypes.length > 0) {
							document.getElementById('locationPenIcon').style.top = '95px';
						} else {
							document.getElementById('locationPenIcon').style.top = '62.5px';
						}
					}

					this.contactTypes = menuOptionOb.contactTypes;
					this.activeContactTypesList = menuOptionOb.contactTypes.filter((ct) => ct.active);
					this.isMyGroup =
						this.filteredGroupUser.findIndex((u) => u.firstName + ' ' + u.lastName === this.currentUser.name) > -1 ? true : false;

					const lastUpdatedBy: User = menuOptionOb.allUsersList.find((p) => p.user_Id === this.problemDetail.lastUpdatedBy);
					this.lastUpdatedByName = userFirstNameLastName(lastUpdatedBy);

					if (this.groupList.length > 0) {
						this.mapGroupUsers();
					}
				}
			});

		this.galleryOptions$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((galleryOptions: NgxGalleryOptions[]) => {
			this.galleryOptions = galleryOptions;
		});

		this.reassignForm = new UntypedFormGroup({
			reassignToggle: new UntypedFormControl(true),
			group: new UntypedFormControl('', [Validators.required]),
			problemType: new UntypedFormControl('', [Validators.required]),
			userName: new UntypedFormControl(null, [Validators.required]),
			reassignNotes: new UntypedFormControl(''),
		});

		this.closeProblemForm = new UntypedFormGroup({
			resolution: new UntypedFormControl('', [Validators.required]),
		});

		this.linkEGForm = new UntypedFormGroup({
			egNumber: new UntypedFormControl('', [Validators.required, Validators.pattern('^[a-zA-Z]{3,4}[0-9]{4}-[0-9]{5}$')]),
			egNote: new UntypedFormControl(''),
		});

		this.linkedCaseEditForm = new UntypedFormGroup({
			linkNotesText: new UntypedFormControl(''),
		});
		this.linkRAPForm = new UntypedFormGroup({
			problemNumber: new UntypedFormControl('', [Validators.required, Validators.pattern('^[a-zA-Z]{3}[0-9]{4}-[0-9]{5}.*$')]),
			egNote: new UntypedFormControl(''),
			relatedLink: new UntypedFormControl('', [Validators.required, Validators.pattern('^link|related*$')]),
			parentNumber: new UntypedFormControl(''),
		});

		this.duplicateCaseForm = new UntypedFormGroup({
			group: new UntypedFormControl(null, Validators.required),
			problemType: new UntypedFormControl(null, Validators.required),
			userName: new UntypedFormControl(null, Validators.required),
			notes: new UntypedFormControl(''),
		});

		this.editContactForm = new UntypedFormGroup({
			contactType: new UntypedFormControl('', Validators.required),
			companyName: new UntypedFormControl(''),
			firstName: new UntypedFormControl(''),
			lastName: new UntypedFormControl(''),
			address: new UntypedFormControl(''),
			email: new UntypedFormControl('', [Validators.email]),
			notes: new UntypedFormControl(''),
			contactId: new UntypedFormControl(''),
			phoneSection: this.formBuilder.group({
				phoneNumArray: new UntypedFormArray([]),
			}),
		});

		this.problemAssignments$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((problemAssignments) => {
			this.problemAssignments = problemAssignments;
		});

		this.newCaseMenu$.pipe(delay(200), takeUntil(this.ngUnsubscribe)).subscribe((m: ProblemMenuConfig[]) => {
			this.menuConfig = m;
		});

		this.problemRoleList$.pipe(delay(200), takeUntil(this.ngUnsubscribe)).subscribe((r) => {
			this.problemRoleList = r;
		});

		this.searchCoordinate$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((sc) => {
			this.searchCoordinate = sc;
		});

		this.mapState$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((m) => {
			this.mapState = m;
			if (!this.searchCoordinate && this.problemDetail.problemId !== 0) {
				const sfc: DnvMapInfo = {
					latlng: this.problemDetail.latLng,
					mapSizeInPixel: '665, 300',
					mapBounds: {
						northWestBound: m.northWestBound,
						southEastBound: m.southEastBound,
					},
				};

				this.store.dispatch(
					new SearchFromCoordinates({
						dnvMapInfo: sfc,
						zoneLookupOnly: false,
					}),
				);
			}
		});

		this.problemContacts$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((problemContacts) => {
			this.problemContacts = problemContacts;
			this.contactsExtracted = true;
		});

		this.store.dispatch(new GetDashBoardProblems({ problemNo: this.problemNo }));
	}

	ngOnDestroy() {
		sessionStorage.removeItem('problemNeighbors');
		window.removeAllListeners('mapLayerLoaded');

		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();

		this.routeSubscription.unsubscribe();
		this.scrollSubscription.unsubscribe();

		document.getElementsByTagName('title')[0].text = this.titleText;
	}

	goToPreviousProblem() {
		this.store.dispatch(new SetProblemAttachmentsImagesNull());
		this.galleryReady = false;
		this.router.navigateByUrl('/problemdetails?ProblemNo=' + this.previousProblem);
	}

	goToNextProblem() {
		this.store.dispatch(new SetProblemAttachmentsImagesNull());
		this.galleryReady = false;
		this.router.navigateByUrl('/problemdetails?ProblemNo=' + this.nextProblem);
	}

	groupBy = function(xs: string[], key: string) {
		return xs.reduce(function(rv: any, x: any) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	};

	imagesReady() {
		console.log('Some new images came...');
		this.galleryReady = true;
	}

	get f() {
		return this.editContactForm.get('phoneSection');
	}
	get pnArr() {
		return this.f.get('phoneNumArray') as UntypedFormArray;
	}

	waitUntilReadyToExport() {
		const interval = setInterval(() => {
			let problemNo = document.querySelector(`.${this.problemNo}_details .problemNo`) as any;
			let problemTypes = document.querySelector(`.${this.problemNo}_details .problemType`) as any;
			let overviewElements = document.querySelectorAll(`.${this.problemNo}_details #overview ul li`);

			let problemNoLoaded = problemNo?.innerHTML !== '';
			let problemTypesLoaded = problemTypes?.innerText !== '' && problemTypes?.innerText !== 'Loading...';
			let overviewLoaded = overviewElements ? Array.from(overviewElements).some((li: any) => li.textContent !== '') : false;

			let mapMarkerLoaded = document.querySelector(`.${this.problemNo}_details .leaflet-marker-icon`) as any;
			let photosLoaded =
				this.attachmentsExtracted &&
				((this.attachmentImageCount > 0 &&
					this.galleryReady &&
					document.querySelector(`.${this.problemNo}_details .ngx-gallery-image`) !== null) ||
					this.attachmentImageCount === 0);

			if (
				problemNoLoaded &&
				problemTypesLoaded &&
				overviewLoaded &&
				photosLoaded &&
				this.mapLayerLoaded &&
				mapMarkerLoaded &&
				this.contactsExtracted &&
				this.activitiesExtracted &&
				this.linkedCasesExtracted
			) {
				clearInterval(interval);
				problemNoLoaded = null;
				problemTypesLoaded = null;
				overviewLoaded = null;
				mapMarkerLoaded = null;
				photosLoaded = null;

				this.ngUnsubscribe.next();
				this.ngUnsubscribe.unsubscribe();
				document.dispatchEvent(new Event('batchExport_problemLoaded'));
			}
		}, 25);
	}

	ngAfterViewInit() {
		// This leads to ExpressionChangedAfterItHasBeenCheckedError...unless a delay is added
		this.clickObservable$ = fromEvent<MouseEvent>(window, 'click');

		this.scrollObservable$ = fromEvent(window, 'scroll');
		this.scrollSubscription = this.scrollObservable$
			.pipe(
				delay(0),
				map((e: Event): string => {
					if (!this.sidebarClick) {
						let smallestDistance = 10000;
						let closestElement = '';
						const children = (e.target as Document).documentElement.getElementsByTagName('section');
						const scrollTop =
							(e.target as Document).documentElement.scrollTop === 0 // height of scrolled content
								? document.body.scrollTop
								: (e.target as Document).documentElement.scrollTop;
						const parentOffset = (e.target as Document).documentElement.offsetHeight; // The window height

						// element.offsetTop = top of element on page
						for (const element of Array.from(children)) {
							// 250 padding so the highlighted section changes only after the section title becomes visible at the bottom of the page
							const distance = Math.abs(scrollTop - element.offsetTop);
							if (distance < smallestDistance && element.offsetTop < scrollTop + parentOffset - 250) {
								smallestDistance = distance;
								closestElement = element.id;
							}
						}

						return closestElement;
					}

					this.sidebarClick = false;
					return '';
				}),
				filter((x: string) => isDashboardTabView(x)), // only let DashboardTabView pass through
				distinctUntilChanged(), // and only if it changed
			)
			.subscribe((x: DashboardTabView) => {
				this.currentSection = x;
				this.store.dispatch(new SetDashboardTabView(x));
			});

		// add one field to phoneNum arrays
		this.pnArr.push(
			this.formBuilder.group(
				{
					phoneNum: '',
					phoneType: '',
					contactPhone_Id: '0',
				},
				{ validator: validatePhone },
			),
		);

		this.fragmentSubscription = this.route.fragment.pipe(takeUntil(this.ngUnsubscribe)).subscribe((fragment) => {
			this.fragment = fragment;
		});

		// for populating reassignForm
		// combineLatest([this.allUsers$, this.groupUsers$])
		//   .pipe(
		//     delay(200),
		//     takeUntil(this.ngUnsubscribe),
		//   )
		//   .subscribe(
		//     ([allUsers, groupUsers]) => {
		//       const usersIDList = groupUsers.filter(g => g.group_RefId === this.problemDetail.group_RefId).map(g => g.user_RefId);
		//       this.filteredUsersByGroup = allUsers.filter(a => usersIDList.indexOf(a.user_Id) > -1);
		//     });
	}

	ngAfterViewChecked(): void {
		try {
			if (!this.fragmentSubscription.closed) {
				document.querySelector('#' + this.fragment).scrollIntoView();
				this.fragmentSubscription.unsubscribe();
				this.fragment = null;
			}
		} catch (e) {}
	}

	fireMessageToast(messageOptions: MessageToastOptions) {
		this.store.dispatch(
			new ToastUserNotification({
				type: messageOptions.type,
				title: messageOptions.title,
				message: messageOptions.message,
				options: {
					disableTimeOut: false,
					closeButton: true,
					enableHtml: true,
					timeOut: 7000,
				},
			}),
		);
	}

	findAllGroupUser(menuOptionOb: MenuItem): GroupUser[] {
		// Returns all user within a group
		const currentGroupAllUser = menuOptionOb.groupUser.filter((g) => g.group_RefId === this.problemDetail.group_RefId);

		return currentGroupAllUser;
	}

	onMapUpdate(action: any) {
		if (action.type) {
			this.store.dispatch(action);
		} else if (action.length == 1) {
			this.store.dispatch(action[0]);
		} else {
			action.forEach((act: DnvMapAction) => {
				this.store.dispatch(act);
			});
		}
	}

	onMoveChange(state: DnvMapState) {
		this.store.dispatch(new CenterMap({ lat: state.centerPoint.lat, lng: state.centerPoint.lng }));
	}

	onZoomChange(state: DnvMapState) {
		this.store.dispatch(new SetZoom(state.zoomLevel));
	}

	dashboardTabViewChange(menu: DashboardTabView) {
		this.store.dispatch(new SetDashboardTabView(menu));
		this.sidebarClick = true;
	}

	SaveActivity(activity: { workOrderTypeId: number; activity: Activity }) {
		if (activity.workOrderTypeId > 0) {
			this.inProgressActivityText$ = of('Creating Work Order...');
			this.store.dispatch(new SetInProgressActivity(true));
			// WorkOrder
			this.store.dispatch(new SubmitWorkOrder({ workOrderTypeRefId: activity.workOrderTypeId, activity: activity.activity }));
		} else {
			this.store.dispatch(new AddActivity({ caseNumber: this.problemNo, activity: activity.activity }));
		}
	}

	UpdateActivity(editedActivity: { workOrderTypeId: number; activityId: number; activity: Activity; cancelWO: boolean }) {
		this.inProgressActivityText$ = of('Updating Work Order...');
		this.store.dispatch(new SetInProgressActivity(true));
		if (editedActivity.cancelWO) {
			// Edit and Delete Work Order from Activity
			this.store.dispatch(new DeleteWorkOrderByActivityId({ activityId: editedActivity.activityId, activity: editedActivity.activity }));
		} else if (editedActivity.workOrderTypeId > 0) {
			// Edit and Add Work Order to Activity
			this.store.dispatch(
				new AddWorkOrder({
					workOrderTypeRefId: editedActivity.workOrderTypeId,
					activityId: editedActivity.activityId,
					activity: editedActivity.activity,
				}),
			);
		} else {
			this.store.dispatch(new UpdateActivity({ activityId: editedActivity.activityId, activity: editedActivity.activity }));
		}
	}

	reassign() {
		let role: Role[] = null;
		let user = null;
		if (this.problemRoleList.length > 0 && this.problemDetail.problemRole !== null) {
			role = this.problemRoleList.filter((r) => r.name === this.problemDetail.problemRole);
		}

		if (role === null && this.assignedToUser === null) {
			// this.reassignForm.get('userName').setValue(0);
			this.reassignForm.get('userName').setValue(null);
		} else if (this.assignedToUser !== null && !this.assignedToUser.active) {
			this.reassignForm.get('userName').setValue(null);
		} else if (role) {
			const assignedToRole = this.mappedUsers.find((u) => u.role_Id === role[0].role_Id);
			this.reassignForm.get('userName').setValue(assignedToRole);
		} else {
			// Look for specific user at specific group.
			user = this.mappedUsers.find((u) => u.groupId === this.problemDetail.group_RefId && u.user_Id === this.assignedToUser.user_Id);
			if (!user) {
				// Look for the user in any group.
				user = this.mappedUsers.find((u) => u.user_Id === this.assignedToUser.user_Id);
			}
			this.reassignForm.get('userName').setValue(user);
		}

		// dispatch SearchFromCoordinate
		// this.dispatchSearchFromCoordinate();
		// add validators
		this.reassignForm.get('userName').setValidators([Validators.required]);
		this.reassignForm.get('userName').updateValueAndValidity();

		const defaultGroup = this.groupList.filter((g) => g.group_Id === this.problemDetail.group_RefId);
		const probType = this.allProblemTypes.filter((p) => p.problemType_Id === this.problemDetail.problemType_RefId);

		this.reassignForm.get('group').setValue(defaultGroup[0]);
		this.reassignForm.get('problemType').setValue(probType[0]);
		this.groupUsers = this.mappedUsers.filter((user) => user.groupId === defaultGroup[0].group_Id && user.user.active);
		this.setDefaultUser();
		// this.mapGroupUsers();

		this.reassignForm.get('reassignToggle').setValue(true);
		this.filterProblemTypes();
		this.reassignForm.markAsUntouched();
		this.open(this.modalReassign);
	}

	getProblemStatusClassName(status: string) {
		// Remove spaces
		const formattedClassName = status.replace(/\s+/g, '');
		return formattedClassName.toLowerCase();
	}

	// opens modal for changing status
	setStatus(status: string) {
		this.open(this.modalStatus);
		this.newStatus = status;
	}

	open(modal: TemplateRef<any>) {
		this.modal = this.modalService.open(modal, { backdrop: 'static' });
		// this.modal = this.modalService.open(modal, { backdrop: 'static', centered: true });
	}

	close() {
		if (this.modal) {
			this.modal.close();
			this.reassignForm.reset();
			this.editContactForm.reset();
			this.duplicateCaseForm.reset();
			this.assignChangeMsg = '';
			this.showAssignChange = false;
		}
	}

	closeCityworksView() {
		if (this.modal) {
			this.modal.close();
			this.store.dispatch(new ClearCityworksRequestView());
		}
	}

	closeAssetDialog() {
		if (this.modal) {
			const dbAsset = this.assetState.filter((a) => a.problem_RefId === this.problemDetail.problemId);
			const mapFeatureLayers: DnvFeatureLayer[] = [];

			if (dbAsset && dbAsset.length > 0) {
				this.store.dispatch(new RemoveFeatureLayers(this.mapState.featureLayers));

				const assetIds = dbAsset.reduce((r: any, a: any) => {
					// console.log("a", a || 'empty');
					// console.log('r', r || 'empty');
					r[a.featureLayer_UId] = [...(r[a.featureLayer_UId] || []), a.gisAssetId];
					return r;
				}, []);

				// Need to use json parse to get a deep copy. Or else it would modified the state (WHY????)
				const newFeatureLayer: LayerState = JSON.parse(JSON.stringify(this.layerState));
				newFeatureLayer.layers.forEach((l: any) => {
					if (assetIds[l.featureLayers[0].uId] && assetIds[l.featureLayers[0].uId].length > 0) {
						let asset_Id = '';
						assetIds[l.featureLayers[0].uId].forEach((a: string) => {
							asset_Id += "'" + a + "',";
						});

						if (asset_Id) {
							l.featureLayers[0].whereClause = 'Asset_Id in (' + asset_Id.slice(0, -1) + ')';

							mapFeatureLayers.push(l.featureLayers[0]);
						}
					}
				});
				this.store.dispatch(new SetMapFeatureLayers(mapFeatureLayers));
			} else {
				this.store.dispatch(new SetMapFeatureLayers([]));
			}

			this.modal.dismiss();
			this.closeProblemForm.reset();
		}
	}

	closeDeleteAssetDialog() {
		if (this.modal) {
			this.modal.dismiss();
		}
	}

	dismiss() {
		if (this.modal) {
			this.modal.dismiss();
			this.reassignForm.reset();
			this.assignChangeMsg = '';
			this.showAssignChange = false;
		}
	}

	// dismisses modal for 'closed' status
	dismissClose() {
		if (this.modal) {
			this.modal.dismiss();
			this.closeProblemForm.reset();
		}
	}

	getAssignedToName() {
		if (this.assignedToUser) {
			let inactiveMsg = '';
			if (!this.assignedToUser.active) {
				inactiveMsg = ' (inactive)';
			}

			if (this.assignedToUser.firstName === 'Cityworks') {
				return this.assignedToUser.firstName;
			}

			return this.assignedToUser.firstName + ' ' + this.assignedToUser.lastName + ' - ' + this.assignedToUser.email + inactiveMsg;
		} else if (this.problemDetail.problemRole) {
			return this.problemDetail.problemRole;
		} else {
			return 'Unassigned';
		}
	}

	transferProblemToCityworks() {
		this.store.dispatch(new CityworksTransferRequest({ caseNo: this.problemDetail.problemNo }));
	}

	isAssignedToMe(): boolean {
		return this.assignedToUser === this.assignToMeUser;
	}

	btnAddAsset() {
		const asset: Asset = {
			asset_Id: 0,
			gisAssetId: this.assetId,
			featureLayer_UId: this.assetUId,
			problem_RefId: this.problemDetail.problemId,
		};

		this.store.dispatch(new AddAsset({ caseNo: this.problemDetail.problemNo, asset: asset }));
		this.close();
	}

	onDeleteAsset(asset: Asset) {
		this.assetId = asset.gisAssetId;
		this.assetToDelete = asset;
		this.open(this.modalDeleteAsset);
	}

	btnDeleteAsset() {
		this.assetUId = null;
		this.assetId = null;
		this.location.replaceState('/problemdetails?ProblemNo=' + this.problemDetail.problemNo);
		this.store.dispatch(new DeleteAsset({ caseNo: this.problemDetail.problemNo, asset: this.assetToDelete }));
		this.close();
	}

	onAssignToMe() {
		const probType = this.allProblemTypes.filter((p) => p.problemType_Id === this.problemDetail.problemType_RefId);
		this.reassignForm.get('problemType').setValue(probType[0]);
		const grp = this.groupList.filter((g) => g.group_Id === this.problemDetail.group_RefId);

		let validAssignableUsers = this.menuOption.groupUser.filter((gu) => gu.group_RefId === grp[0].group_Id);
		let isValidAssignment = validAssignableUsers.some((gu) => gu.user_RefId === this.assignToMeUser.user_Id);

		if (isValidAssignment) {
			this.reassignForm.get('userName').setValue({
				groupId: grp[0].group_Id,
				groupName: grp[0].name,
				name: this.assignToMeUser.firstName + ' ' + this.assignToMeUser.lastName,
				user: this.assignToMeUser,
				user_Id: this.assignToMeUser.user_Id,
			});
			this.reassignForm.get('group').setValue(grp[0]);
			this.onSubmitReassign(true);
		} else {
			const userNotification: UserNotification = {
				type: 'error',
				title: 'Invalid user assignment',
				message: `
					You cannot assign this problem to yourself because you are not part of the 
					group this problem is assigned to. Please use the Reassign feature to assign 
					the problem to your group and yourself.
				`,
				options: {
					disableTimeOut: false,
					closeButton: true,
					enableHtml: true,
					timeOut: 5000,
				},
			};

			this.store.dispatch(new ToastUserNotification(userNotification));
		}
	}

	getUserFullName = (user: User) => `${user.firstName} ${user.lastName}`;

	onSubmitReassign(assignToMe: boolean = false) {
		const assignee = this.reassignForm.value.userName;
		let newRole: Role = null;
		let newUser: User = null;
		let reassignText = '';

		let newAssignee = 'Unassigned';
		if (assignee && assignee.role_Id !== undefined) {
			newRole = assignee;
			newAssignee = assignee.name;
		} else if (assignee && assignee.user_Id !== undefined) {
			newUser = assignee;
			newAssignee = assignee.name;
		}

		// Populate ReassignText based on previous group to new group
		if (this.problemDetail.group_RefId !== this.reassignForm.get('group').value.group_Id) {
			// display gruops
			reassignText = 'Issue reassigned from ' + this.problemDetail.problemGroup + ' to ' + this.reassignForm.get('group').value.name;
		} else {
			//  display users
			reassignText =
				'Issue reassigned from ' +
				(this.assignedTo && this.assignedTo.length > 0
					? this.assignedTo
					: this.problemDetail.problemRole && this.problemDetail.problemRole.length > 0
					? this.problemDetail.problemRole
					: 'unassigned') +
				' to ' +
				newAssignee;
		}

		const notes =
			this.reassignForm.value.reassignNotes && this.reassignForm.value.reassignNotes.length > 0
				? '. Reassign Notes: ' + this.reassignForm.value.reassignNotes
				: '';

		this.store.dispatch(
			new ReassignProblem({
				caseNo: this.problemDetail.problemNo,
				problem_Id: this.problemDetail.problemId,
				user_RefId: newUser !== null ? newUser.user_Id : null,
				role_RefId: newRole !== null ? newRole.role_Id : null,
				problemType_RefId:
					this.reassignForm.get('problemType').value === null ? null : this.reassignForm.get('problemType').value.problemType_Id,
				group_RefId: this.reassignForm.get('group').value.group_Id,
				notes: reassignText + notes,
				origNote: this.reassignForm.value.reassignNotes,
				assignToMe: assignToMe,
			}),
		);

		this.reassignForm.reset();
		this.assignChangeMsg = '';
		this.showAssignChange = false;
		this.close();
	}

	filterDuplicateDropdown(groupId?: number) {
		const selectedGrp = this.duplicateCaseForm.get('group').value;
		const grpId = groupId !== undefined ? groupId : selectedGrp.group_Id;
		this.groupUsers = this.mappedUsers.filter((user) => user.groupId === grpId && user.user.active);
		this.filterProblemTypes(grpId, this.duplicateCaseForm);
		this.duplicateCaseForm.get('userName').setValue(null);
		// this.setDefaultUser();
	}

	filterReassignDropDowns(groupId?: number) {
		const selectedGrp = this.reassignForm.get('group').value;
		const grpId = groupId !== undefined ? groupId : selectedGrp.group_Id;
		this.groupUsers = this.mappedUsers.filter((user) => user.groupId === grpId && user.user.active);
		this.filterProblemTypes(grpId);
		this.setDefaultUser();
	}

	updateProblemStatus(status: string) {
		this.setStatus(status);
	}

	updateProblemType(evt: any) {
		// const selectedProbTypeIndex = evt.target.selectedIndex;
		// const probType = this.filteredProblemTypes[selectedProbTypeIndex];
		// const probType = evt.problemType_Id;
		const newProblem = Object.assign({}, this.problemDetail, {
			problemType_RefId: evt.problemType_Id,
		});
		const newProblemDB = this.transformProblem(newProblem);
		this.store.dispatch(new UpdateProblem({ problemId: this.problemDetail.problemId, problem: newProblemDB }));
		this.showProbTypeDropdown = false;
	}

	updateProblemSubType(evt: any) {
		const probSubType = this.allProblemSubTypes.find(
			(pst) => pst.problemSubType_Name === evt.problemSubType_Name && pst.problemType_RefId === this.problemDetail.problemType_RefId,
		);

		// if (probSubType != null) {
		const newProblem = Object.assign({}, this.problemDetail, {
			problemSubType_RefId: probSubType?.problemSubType_Id || null,
		});

		const newProblemDB = this.transformProblem(newProblem);
		this.store.dispatch(new UpdateProblem({ problemId: this.problemDetail.problemId, problem: newProblemDB }));
		// }
	}

	updateProblemSource(evt: any) {
		const newProblem = Object.assign({}, this.problemDetail, {
			problemSource: evt.problemSource_Name,
		});
		const newProblemDB = this.transformProblem(newProblem);
		this.store.dispatch(new UpdateProblem({ problemId: this.problemDetail.problemId, problem: newProblemDB }));
	}

	updateReceivedFrom(evt: any) {
		const newProblem = Object.assign({}, this.problemDetail, {
			problemReceivedFrom: evt.problemReceivedFrom_Name,
		});
		const newProblemDB = this.transformProblem(newProblem);
		this.store.dispatch(new UpdateProblem({ problemId: this.problemDetail.problemId, problem: newProblemDB }));
	}

	updateProblemPriority(evt: any) {
		if (this.problemDetail.priority !== evt.priority) {
			const newProblem = Object.assign({}, this.problemDetail, {
				priority: evt.priority,
			});
			const newProblemDB = this.transformProblem(newProblem);
			this.store.dispatch(new UpdateProblem({ problemId: this.problemDetail.problemId, problem: newProblemDB }));
		}
	}

	updateLocation(loc: string) {
		var scPayload = {
			id: this.selected.id,
			name: loc,
			type: this.selected.type,
		};
		if (this.selected.id > 0) {
			this.locationService.getLocationCoordinates(scPayload).subscribe((coordinates) => {
				const newProblem = Object.assign({}, this.problemDetail, {
					problemLocation: loc,
					latLng: { lat: coordinates.lat, lng: coordinates.lng },
				});
				const newProblemDB = this.transformProblem(newProblem);
				this.store.dispatch(new UpdateProblem({ problemId: this.problemDetail.problemId, problem: newProblemDB }));
			});
		} else {
			// location type is not defined, update location description
			if (this.quillDescEditor) {
				const locDesc = this.quillEditForm.get('locEditor').value;
				this.updateLocDesc(locDesc);
			}
		}

		this.locFocus = false;
		document.getElementById('locBtns').style.visibility = 'hidden';

		// this.quillEditForm.get('locEditor').disable();
	}

	updateLocDesc(locDesc: string) {
		const probStatus: ProblemStatus = this.problemStatusList.find((s) => s.problemStatus_Name === this.problemDetail.problemStatus.trim());
		const probSource: ProblemSource = this.problemSourceList.find((s) => s.problemSource_Name === this.problemDetail.problemSource.trim());
		const receivedFrom: ProblemReceived = this.problemReceivedList.find(
			(s) => s.problemReceivedFrom_Name === this.problemDetail.problemReceivedFrom.trim(),
		);

		const modifiedProblem: NewProblem = {
			problem_Id: this.problemDetail.problemId,
			caseNo: this.problemDetail.problemNo,
			group_RefId: this.problemDetail.group_RefId,
			problemType_RefId: this.problemDetail.problemType_RefId,
			description: this.problemDetail.problemDescription,
			problemStatus_RefId: probStatus.problemStatus_Id,
			problemSource_RefId: probSource.problemSource_Id,
			location_Description: locDesc,
			//location_Description_Origin: this.fg.get('addressSearchOrigin').value,
			location_Longitude: this.problemDetail.latLng.lng,
			location_Latitude: this.problemDetail.latLng.lat,
			problemPriority_RefId: this.problemDetail.problemPriority_RefId,
			problemReceivedFrom_RefId: receivedFrom.problemReceivedFrom_Id,
		} as NewProblem;

		this.store.dispatch(new UpdateProblem({ problemId: this.problemDetail.problemId, problem: modifiedProblem }));
	}

	updateLocClick() {
		const loc = this.quillEditForm.get('locEditor').value;
		document.getElementById('locBtns').style.visibility = 'hidden';

		if (loc.name) {
			this.updateLocation(loc.name);
		} else {
			if (this.quillEditForm.get('locEditor').valid && this.quillEditForm.get('locEditor').touched) {
				this.updateLocation(loc);
			} else {
				// user clicked off without changing
				this.locFocus = false;
			}
		}
	}

	updateDescBlur(e: { editor: Quill; source: any }) {
		const quillHTML = e.editor.root?.innerHTML;
		const quillText = e.editor.getText();
		if (quillText.trim().length > 0 && this.quillEditForm.get('descEditor').dirty) {
			this.updateDescription(quillText.trim(), quillHTML);
		}
	}

	updateDescClick() {
		if (this.quillDescEditor) {
			const quillHTML = this.quillDescEditor.root?.innerHTML;
			const quillText = this.quillDescEditor.getText();
			this.updateDescription(quillText.trim(), quillHTML);
		}
	}

	updateDescription(descText: string = '', descHTML: string = '') {
		const newProblem = Object.assign({}, this.problemDetail, {
			problemDescription: convertQuillToHTML(descHTML, descText),
		});
		const newProblemDB = this.transformProblem(newProblem);
		this.store.dispatch(new UpdateProblem({ problemId: this.problemDetail.problemId, problem: newProblemDB }));
		this.quillDescFocus = false;
		this.quillEditForm.get('descEditor').markAsPristine();
	}

	getDescHistory() {
		this.store.dispatch(new GetDescriptionHistory(this.problemNo));
		this.hideHistory = false;
	}

	hideDescHistory() {
		this.hideHistory = true;
	}

	transformProblem(problem: Problem) {
		const probType: ProblemType = this.allProblemTypes.find((t) => t.problemType_Id === problem.problemType_RefId);
		const probSubType: SelectedProblemSubType = this.allProblemSubTypes.find((pst) => pst.problemSubType_Id === problem.problemSubType_RefId);
		const probStatus: ProblemStatus = this.problemStatusList.find((s) => s.problemStatus_Name === problem.problemStatus.trim());
		const probSource: ProblemSource = this.problemSourceList.find((s) => s.problemSource_Name === problem.problemSource.trim());
		const priority: ProblemPriority = this.problemPriorityList.find((s) => s.priority === problem.priority);
		const probReceivedFrom: ProblemReceived = this.problemReceivedList.find(
			(s) => s.problemReceivedFrom_Name === (problem.problemReceivedFrom || 'Resident').trim(),
		);

		const newProblem: NewProblem = {
			// group_RefId: ??? TODO
			problemType_RefId: probType.problemType_Id,
			problemSubType_RefId: probSubType?.problemSubType_Id,
			description: problem.problemDescription,
			problemStatus_RefId: probStatus.problemStatus_Id,
			problemPriority_RefId: priority.problemPriority_Id,
			problemSource_RefId: probSource.problemSource_Id,
			location_Description: problem.problemLocation,
			problem_Id: this.problemDetail.problemId,
			location_Latitude: problem.latLng.lat,
			location_Longitude: problem.latLng.lng,
			problemReceivedFrom_RefId: probReceivedFrom.problemReceivedFrom_Id,
		} as NewProblem;

		return newProblem;
	}

	undoEditLoc() {
		this.locEditor.nativeElement.value = this.problemDetail.problemLocation;
		// this.quillEditForm.get('locEditor').setValue(this.problemDetail.problemLocation);
		// this.quillEditForm.get('locEditor').disable();
		this.locFocus = false;
		this.undoEdit = false;
		document.getElementById('locBtns').style.visibility = 'hidden';
	}

	undoEditDesc() {
		const description = this.problemDetail.problemDescription.replaceAll('<br>', '\n').replaceAll('</br>', '\n');

		// if the original description used an HTML list, store as html string, otherwise store as plain text
		if (description.includes('<ul>') || description.includes('<ol>')) {
			const delta = this.quillDescEditor.clipboard.convert({ text: description });
			this.quillDescEditor.setContents(delta, 'silent');
		} else {
			this.quillDescEditor.setText(description.trim());
		}

		this.quillDescFocus = false;
		this.quillEditForm.get('descEditor').markAsUntouched();
	}

	onSubmitStatus() {
		let action = '';
		if (this.newStatus === 'Open') {
			action = 'Re-opened';
		} else if (this.newStatus === 'Hold') {
			action = 'Put on Hold';
		} else if (this.newStatus === 'Closed') {
			action = 'Closed';
		} else {
			action = 'In Progress';
		}

		let reason = ' (did not provide reason)';
		if (this.closeProblemForm.get('resolution').value != null && this.closeProblemForm.get('resolution').value.length > 0) {
			reason = ' with the following reason: ' + this.closeProblemForm.get('resolution').value;
		}
		const resolutionText = action + ' by ' + this.assignToMeUser.firstName + ' ' + this.assignToMeUser.lastName + reason;

		const activityType = this.activityTypes.find((a) => a.activityType_Name.toLowerCase().indexOf(this.newStatus.toLowerCase()) > -1);

		const newActivity = ({
			activityType_RefId: activityType ? activityType.activityType_Id : 0,
			note: resolutionText,
			user_RefId: null,
			problem_RefId: this.problemDetail.problemId,
			activityDate: new Date(),
			activityDateClosed: new Date(),
			activityFollowUpdate: null,
			createdBy: this.assignToMeUser.user_Id,
		} as unknown) as Activity;
		// save activity
		this.store.dispatch(new AddActivity({ caseNumber: this.problemNo, activity: newActivity }));

		const newProblem = Object.assign({}, this.problemDetail, {
			problemStatus: this.newStatus,
		});
		const newProblemDB = this.transformProblem(newProblem);
		// update problem
		this.store.dispatch(
			new DelayedActionBy1([
				new UpdateProblem({
					problemId: this.problemDetail.problemId,
					resolution: this.closeProblemForm.get('resolution').value,
					problem: newProblemDB,
				}),
			]),
		);

		this.closeProblemForm.reset();
		this.close();
	}

	onDescEditorCreated(e: any) {
		this.quillDescEditor = e;
	}

	hasDescFocus(e: { editor: any; oldRange: any; range: any; source: string }) {
		if (e.editor.hasFocus()) {
			this.quillDescFocus = true;
		} else {
			this.quillDescFocus = false;
		}
	}

	onBlur() {
		if (!this.undoEdit) {
			this.updateLocClick();
		} else {
			this.undoEditLoc();
			this.quillEditForm.get('locEditor').markAsUntouched();
			this.undoEdit = false;
		}
	}

	onSelectItem(event: NgbTypeaheadSelectItemEvent) {
		this.selected = event.item;
		this.onSearchClick.emit(this.selected);
	}

	onSelectEGNumber(event: NgbTypeaheadSelectItemEvent) {
		this.egNumber = event.item;
	}

	onSelectRAPNumber(event: NgbTypeaheadSelectItemEvent) {
		this.rapNumber = event.item.substring(0, 13);
		this.dbRapNumber = '';
		this.sharedSearchRapNumber = event.item.substring(0, 13);
		this.linkRAPForm.get('problemNumber').setValue('');

		// this.relatedLinkNumber = event.item.substring(0, 13);
		// //this sets the default radio button
		// this.linkRAPForm.get('relatedLink').setValue(event.item.substring(0, 13));

		this.store.dispatch(
			new GetProblemLinkedCasesAddMenu({
				caseNo: this.problemDetail.problemNo,
				searchCaseNo: event.item.substring(0, 13),
			}),
		);
	}

	onSelectRAPNumberDB(event: any) {
		if (event) {
			this.dbRapNumber = event.substring(0, 13);
			this.rapNumber = '';
			this.sharedSearchRapNumber = event.substring(0, 13);

			// this.relatedLinkNumber = event.substring(0, 13);
			// // this sets the default radio button
			//   this.linkRAPForm.get('relatedLink').setValue(event.substring(0, 13));

			this.store.dispatch(
				new GetProblemLinkedCasesAddMenu({
					caseNo: this.problemDetail.problemNo,
					searchCaseNo: event.substring(0, 13),
				}),
			);
		}
	}

	showTooltip() {
		(document.getElementsByClassName('tooltipText') as any)[0].style.visibility = 'visible';
		(document.getElementsByClassName('tooltipArrow') as any)[0].style.visibility = 'visible';
	}

	hideToolTip() {
		(document.getElementsByClassName('tooltipText') as any)[0].style.visibility = 'hidden';
		(document.getElementsByClassName('tooltipArrow') as any)[0].style.visibility = 'hidden';
	}

	getClass(type: number): string {
		let result = this.defaultIcon;
		if (this.dnvSearchState.icons) {
			const icon = this.dnvSearchState.icons.find((x: { id: number }) => x.id === type);
			if (icon) {
				result = icon.fontAwesome;
			}
		}
		return result;
	}

	enableLocEdit() {
		this.quillEditForm.get('locEditor').enable();
		this.locEditor?.nativeElement?.focus();
		this.locFocus = true;
		document.getElementById('locBtns').style.visibility = 'visible';

		if (this.filteredProblemSubTypes.length > 0) {
			document.getElementById('locBtns').style.top = '60px';
		} else {
			document.getElementById('locBtns').style.top = '28px';
		}
	}

	addAttachmentsToProblem(prob: Problem, event: UploadAttachmentsPayload) {
		const payload = Object.assign({}, event, {
			caseNo: this.problemNo,
			attachment: { files: event.attachment, state: 'files' },
			postUploadActions: event.postUploadActions,
			description: event.description,
		});
		this.store.dispatch(new UploadAttachments(payload));
	}

	downloadEdocsFile(doc: { docNum: number; desc: string }) {
		if (doc.docNum > 0) {
			this.store.dispatch(new DownloadEdocsFile(doc.docNum));
		} else if (doc.docNum === 0) {
			this.store.dispatch(new DownloadAzureFile(doc.desc));
		}
	}

	editContact(id: number) {
		this.contactFormTitle = 'Edit ';
		let contact = this.problemContacts.find((x) => x.contactId === id);

		this.editContactForm.get('contactType').setValue(contact.contactType);
		this.editContactForm.get('firstName').setValue(contact.firstName);
		this.editContactForm.get('lastName').setValue(contact.lastName);
		this.editContactForm.get('address').setValue(contact.street);

		this.editContactForm.get('email').setValue(contact.email);
		this.editContactForm.get('contactId').setValue(contact.contactId);
		this.editContactForm.get('notes').setValue(contact.notes);

		const conType = this.contactTypes.find((x) => x.contactType_Name === contact.contactType);

		this.editContactForm.get('contactType').setValue(conType);
		this.editContactForm.get('companyName').setValue(contact.companyName);

		if (conType.contactType_Name === 'Reporter') {
			this.editContactForm.get('contactType').disable();
		}

		this.setPhones(contact.phone);
		this.open(this.modalContact);
	}

	setPhones(phone: ContactPhone[]) {
		this.resetPhoneArray();

		if (this.pnArr.length === 0) {
			this.addPhoneFields();
		}

		for (let i = 0; i < phone.length; i++) {
			if (i > 0) {
				this.addPhoneFields();
			}
			this.pnArr
				.at(i)
				.get('phoneNum')
				.setValue(phone[i].phone);
			this.pnArr
				.at(i)
				.get('phoneType')
				.setValue(phone[i].phoneType_RefId);
			this.pnArr
				.at(i)
				.get('contactPhone_Id')
				.setValue(phone[i].contactPhone_Id);
		}
	}

	resetPhoneArray() {
		for (let i = this.pnArr.length - 1; i >= 0; i--) {
			if (i > 0) {
				this.pnArr.removeAt(i);
			} else {
				this.pnArr
					.at(i)
					.get('phoneType')
					.setValue(null);
				this.pnArr
					.at(i)
					.get('phoneNum')
					.setValue('');
				this.pnArr
					.at(i)
					.get('contactPhone_Id')
					.setValue(0);
			}
		}
	}

	openCancelActivityPrompt(activity: ActivityList) {
		this.activityToCancel = activity;
		this.open(this.cancelActivityModal);
	}

	closeCancelActivity() {
		this.activityToCancel = null;
		this.close();
	}

	cancelActivity() {
		this.store.dispatch(
			new CancelActivity({
				activityId: this.activityToCancel.activity_Id,
				activityNo: this.activityToCancel.activityNo,
				problemNo: this.problemNo,
			}),
		);

		this.closeCancelActivity();
	}

	openRemoveDocumentPrompt(attachment: Attachment) {
		this.attachmentToRemove = attachment;
		this.open(this.removeDocumentModal);
	}

	closeRemoveDocument() {
		this.attachmentToRemove = null;
		this.close();
	}

	removeDocument() {
		this.deleteAttachment(this.attachmentToRemove.attachment_Id);
		this.closeRemoveDocument();
	}

	openUnlinkCasePrompt(linkedCase: LinkedCase) {
		this.linkedCaseToRemove = linkedCase;
		this.open(this.unlinkCaseModal);
	}

	closeUnlinkCasePrompt() {
		this.linkedCaseToRemove = null;
		this.close();
	}

	unlinkCase() {
		const unlinkCasePayload: UnlinkProblemCasePayload = {
			linkedCase_Id: this.linkedCaseToRemove.problemLinked_Id,
			caseNo: this.problemNo,
		};

		this.store.dispatch(new UnlinkProblemCase(unlinkCasePayload));
		this.closeUnlinkCasePrompt();
	}

	updateLinkedCaseNotes(updateCaseNotePayload: UpdateLinkedCasePayload) {
		this.store.dispatch(new UpdateLinkedCaseNotes(updateCaseNotePayload));
	}

	editLinkedCaseDialog(linkedCase: LinkedCase) {
		this.linkedCaseToEdit = linkedCase;
		this.linkNotesText = this.linkedCaseToEdit.notes;
		this.open(this.modalEditLinkedCase);
	}

	getCityworksRequestView(requestId: number) {
		this.store.dispatch(new CityworksRequestView(requestId));
		this.open(this.modalCityworksRequestView);
		this.requestedCityworksViewId = requestId;
	}

	getCityworksPriority(textString: string) {
		switch (textString) {
			case '1':
				return 'Emergency';
			case '2':
				return 'High';
			case '3':
				return 'Medium';
			case '4':
				return 'Low';
			default:
				return 'N/A';
		}
	}

	getStatusTextEntry(textString: string) {
		switch (textString) {
			case 'CLOSED':
				return 'Closed';
			case 'ONHOLD':
				return 'On Hold';
			case 'OPEN':
				return 'Open';
			case 'COMPLETED':
				return 'Completed';
			case 'INPROGRESS':
				return 'In Progress';
			case 'NOTSTARTED':
				return 'Not Started';
			default:
				return 'Open';
		}
	}

	getTextEntry(textString: string) {
		if (textString === '' || textString === null) {
			return 'N/A';
		}

		if (textString.includes('Activity Type:') && textString.includes('Assigned To:') && textString.includes('Activity Date')) {
			let htmlString = '';
			let activityTypeStr = textString.split('Assigned To:')[0].trim();
			let assignedToStr = textString.split('Activity Date:')[0].slice(textString.indexOf('Assigned To:'));
			let activityDateStr = textString.split('Follow-up Date:')[0].slice(textString.indexOf('Activity Date:'));
			let followUpStr = textString.split('Closed Date:')[0].slice(textString.indexOf('Follow-up Date:'));
			let closedDateStr = textString.split('Created By:')[0].slice(textString.indexOf('Closed Date:'));
			let createdByStr = textString.split('Notes:')[0].slice(textString.indexOf('Created By:'));
			let noteStr = textString.split(createdByStr)[1];

			htmlString = `${activityTypeStr}<br>${assignedToStr}<br>${activityDateStr}<br>${followUpStr}<br>${closedDateStr}<br>${createdByStr}<br>${noteStr}`;
			return htmlString;
		}

		return textString;
	}

	getDateEntry(dateEntry: Date) {
		if (dateEntry === null) {
			return 'N/A';
		}

		let date = new Date(dateEntry);
		let longDateDefaultLocale = date.toLocaleDateString(undefined, { dateStyle: 'long' });
		return longDateDefaultLocale;
	}

	onSubmitLinkedCaseEdit() {
		const payload: UpdateLinkedCasePayload = {
			linkedCase_Id: this.linkedCaseToEdit.problemLinked_Id,
			updatedLinkedCase: {
				...this.linkedCaseToEdit,
				notes: this.linkedCaseEditForm.get('linkNotesText').value,
			},
			caseNo: this.problemNo,
		};

		this.updateLinkedCaseNotes(payload);

		if (this.modal) {
			this.linkedCaseEditForm.reset();
			this.linkNotesText = '';
			this.modal.dismiss();
		}
	}

	linkEGDialog(linkedTo: string) {
		if (linkedTo === 'EG') {
			this.open(this.modalLinkEG);
		} else {
			this.open(this.modalLinkRAP);
		}
	}

	onSubmitDuplicateCase() {
		this.modal.close();
		let details = this.duplicateCaseForm.value;
		this.duplicateCaseForm.reset();

		// console.log(details);
		// console.log(this.problemDetail);

		let userNameArr = [];
		// if assigned to doesn't change
		if (typeof details.userName === 'string') {
			userNameArr = details.userName.split('-');
		}

		// if assigned to changed then details.userName is an object and not a string
		const userName = userNameArr.length > 0 ? userNameArr[0].trim() : details.userName.name;

		let notes = details.notes || '';
		let problemNo = this.problemDetail.problemNo;

		let groupId = details.group.group_Id;
		let problemTypeId = details.problemType.problemType_Id;
		let userId =
			this.mappedUsers.filter((u) => u.name === userName).length > 0 ? this.mappedUsers.filter((u) => u.name === userName)[0]?.user_Id : null;
		let roleId =
			this.mappedUsers.filter((u) => u.name === userName).length > 0 ? this.mappedUsers.filter((u) => u.name === userName)[0]?.role_Id : null;
		let problemSubType_Id = null;
		if (this.selectedProblemSubType) {
			problemSubType_Id = this.filteredProblemSubTypes.filter(
				(s) => s.problemSubType_Name === this.selectedProblemSubType.problemSubType_Name,
			)[0].problemSubType_Id;
		}
		const receivedFrom = this.problemReceivedList.filter((p) => p.problemReceivedFrom_Name === this.problemDetail.problemReceivedFrom)[0]
			.problemReceivedFrom_Id;

		let linkedCase: FromProblemLinkedCasePayload = {
			caseNo: problemNo,
			application: 'RAP',
			notes,
			isRelated: false,
			problemOneNumber: problemNo,
			problemTwoNumber: '',
		};

		const newActivity: Activity = {
			activityType_RefId: 23,
			note: '',
			problem_RefId: this.problemDetail.problemId,
			activityDate: new Date(),
			activityDateClosed: new Date(),
			activityFollowUpdate: null,
			createdBy: 0,
		};

		let newDuplicatedCase: DuplicateProblemPayload = {
			activity: newActivity,
			linkedCase,
			originalProblemNo: problemNo,
			groupId,
			problemTypeId,
			ProblemReceivedFrom_RefId: receivedFrom,
			ProblemSubType_RefId: problemSubType_Id,
			userId,
			roleId,
			notes,
		};

		this.store.dispatch(new DuplicateProblem(newDuplicatedCase));
	}

	onSubmitLinkEGCase() {
		// DEV ONLY
		const caseToLink: FromProblemLinkedCasePayload = {
			caseNo: this.problemNo,
			application: 'EnerGov',
			notes: this.linkEGForm.get('egNote').value,
			isRelated: false,
			problemOneNumber: this.problemDetail.problemNo,
			problemTwoNumber: this.egNumber,
		};

		this.store.dispatch(new AddProblemLinkedCase(caseToLink));
		if (this.modal) {
			this.linkEGForm.reset();
			this.egNumber = '';
			this.modal.dismiss();
		}
	}

	onSubmitLinkRAPCase() {
		// DEV ONLY
		const caseToLink: FromProblemLinkedCasePayload = {
			caseNo: this.problemNo,
			application: 'RAP',
			notes: this.linkRAPForm.get('egNote').value,
			isRelated: this.linkRAPForm.get('relatedLink').value === 'link' ? false : true,
			problemOneNumber: this.evaluateProblemOneNumber(),
			problemTwoNumber: this.evaluateProblemTwoNumber(),
		};

		this.store.dispatch(new AddProblemLinkedCase(caseToLink));
		if (this.modal) {
			this.linkRAPForm.reset();
			this.modal.dismiss();
			this.rapNumber = '';
			this.dbRapNumber = '';
			this.sharedSearchRapNumber = '';
			this.store.dispatch(
				new GetProblemLinkedCasesAddMenuSucccess({
					linkPossibility: null,
					parentNumber: null,
					childNumber: null,
					searchNumberStatus: null,
					linkedCases: [],
				}),
			);
		}
	}

	dismissCloseLink() {
		if (this.modal) {
			this.modal.dismiss();
			this.linkRAPForm.reset();
			this.rapNumber = '';
			this.dbRapNumber = '';
			this.sharedSearchRapNumber = '';
			this.store.dispatch(
				new GetProblemLinkedCasesAddMenuSucccess({
					linkPossibility: null,
					parentNumber: null,
					childNumber: null,
					searchNumberStatus: null,
					linkedCases: [],
				}),
			);
		}
	}

	evaluateProblemOneNumber() {
		if (this.linkRAPForm.get('relatedLink').value === 'link') {
			return this.problemDetail.problemNo;
		} else if (this.addLinkLinkedCaseList && this.addLinkLinkedCaseList.linkPossibility === 'ParentAssign|Link') {
			return this.linkRAPForm.get('parentNumber').value;
		} else if (this.addLinkLinkedCaseList && this.addLinkLinkedCaseList.parentNumber) {
			return this.addLinkLinkedCaseList.parentNumber;
		} else {
			return this.problemDetail.problemNo;
		}
	}

	evaluateProblemTwoNumber() {
		if (this.linkRAPForm.get('relatedLink').value === 'link') {
			return this.sharedSearchRapNumber;
		} else if (this.addLinkLinkedCaseList && this.addLinkLinkedCaseList.linkPossibility === 'ParentAssign|Link') {
			if (this.linkRAPForm.get('parentNumber').value === this.sharedSearchRapNumber) {
				return this.problemDetail.problemNo;
			} else {
				return this.sharedSearchRapNumber;
			}
		} else if (this.addLinkLinkedCaseList && this.addLinkLinkedCaseList.childNumber) {
			return this.addLinkLinkedCaseList.childNumber;
		} else {
			return this.sharedSearchRapNumber;
		}
	}

	deleteAttachment(id: number) {
		this.store.dispatch(new DeleteAttachment({ attachmentId: id, caseNo: this.problemNo }));
	}

	getModalLabel(status: string) {
		if (status === 'Closed') {
			return 'Resolution';
		} else {
			return 'Reason';
		}
	}

	// activeContactTypes() {
	// 	return this.contactTypes.filter((ct) => ct.active);
	// }

	updateAttachDescription(attachment: Attachment) {
		this.store.dispatch(new UpdateAttachment({ attachment: attachment, caseNo: this.problemNo }));
	}

	deleteContact(contact: ProblemContact) {
		this.store.dispatch(new DeleteContact({ problem_Id: this.problemDetail.problemId, contacts: [contact] }));
	}

	deletePhone(contactPhone_Id: number, index: number) {
		this.deletePhones.push(contactPhone_Id);
		this.removePhoneField(index);
	}

	addNewContact() {
		if (this.pnArr.length === 0) {
			this.addPhoneFields();
		}
		this.contactFormTitle = 'Add ';
		this.editContactForm.reset();
		this.editContactForm.get('contactType').enable();
		this.resetPhoneArray();
		this.editContactForm.get('contactType').setValue(null);
		this.open(this.modalContact);
	}

	// closes modal for contact modal
	dismissEditContact() {
		if (this.modal) {
			this.editContactForm.reset();
			this.deletePhones = [];
			this.modal.dismiss();
		}
	}

	onSubmitContact() {
		const contactId = this.editContactForm.get('contactId').value > 0 ? this.editContactForm.get('contactId').value : 0;
		const phones: ContactPhone[] = [];
		for (let i = 0; i < this.pnArr.value.length; i++) {
			const contactPhone: ContactPhone = {
				phone: this.pnArr.value[i].phoneNum,
				phoneType_RefId: this.pnArr.value[i].phoneType,
				contact_RefId: contactId,
				contactPhone_Id: this.pnArr.value[i].contactPhone_Id,
			};
			if (contactPhone.phone.length > 0) {
				phones.push(contactPhone);
			}
		}
		const editedContact: ProblemContact = {
			contactId: contactId,
			firstName: this.editContactForm.get('firstName').value,
			lastName: this.editContactForm.get('lastName').value,
			email: this.editContactForm.get('email').value,

			phone: phones,
			street: this.editContactForm.get('address').value,
			notes: this.editContactForm.get('notes').value,
			contactType: this.editContactForm.get('contactType').value.contactType_Name,
			companyName: this.editContactForm.get('companyName').value,
		};

		if (contactId > 0) {
			// edit contact
			this.store.dispatch(new UpdateContact({ contact: editedContact, problemNo: this.problemDetail.problemNo }));
			if (this.deletePhones.length > 0) {
				this.deletePhones.forEach((d) => {
					this.store.dispatch(new DeletePhone({ problem_Id: this.problemDetail.problemId, id: d }));
				});
			}
			this.deletePhones = [];
		} else {
			// add new contact
			this.store.dispatch(
				new AddProblemContacts({
					problem_Id: this.problemDetail.problemId,
					contacts: [editedContact],
				}),
			);
		}

		this.dismissEditContact();
	}

	addPhoneFields() {
		this.pnArr.push(
			this.formBuilder.group(
				{
					phoneNum: '',
					phoneType: '',
					contactPhone_Id: '0',
				},
				{ validator: validatePhone },
			),
		);
		this.editContactForm.markAsDirty();
	}

	removePhoneField(idx: number) {
		this.pnArr.removeAt(idx);
		this.editContactForm.markAsDirty();
	}

	// activeGroups() {
	// 	return this.groupList.filter((g) => g.active);
	// }

	clearPhoneType(fg: any) {
		const phoneNum = fg.get('phoneNum').value;
		if (phoneNum === '') {
			fg.get('phoneType').setValue(null);
		}
	}

	showDeletePhone(fg: any) {
		if (this.contactFormTitle.indexOf('Edit') > -1 && fg.get('contactPhone_Id').value > 0) {
			return true;
		}
		return false;
	}

	createCC() {
		let contactNamesMissing =
			this.problemContacts.length === 0 || this.problemContacts.some((contact) => !contact.firstName || !contact.lastName);

		let problemIsChild = this.linkedCaseList.some((linkedCase) => linkedCase.isRelated && linkedCase.problemTwoNumber === this.problemNo);

		if (contactNamesMissing) {
			let message =
				this.problemContacts.length === 0
					? 'Please provide a contact with both the first and last names to create a code case.'
					: 'Please provide a first and last name on all provided contacts to create a code case.';

			this.store.dispatch(
				new ToastUserNotification({
					type: 'error',
					title: 'Code Case Creation Error',
					message,
					options: {
						disableTimeOut: false,
						closeButton: true,
						enableHtml: true,
						timeOut: 5000,
					},
				}),
			);
		} else if (problemIsChild) {
			let message = 'Code case creation is only supported from the parent case. Please navigate to the parent case and try again.';
			this.store.dispatch(
				new ToastUserNotification({
					type: 'error',
					title: 'Code Case Creation Error',
					message,
					options: {
						disableTimeOut: false,
						closeButton: true,
						enableHtml: true,
						timeOut: 5000,
					},
				}),
			);
		} else {
			this.store.dispatch(
				new AddCodeCase({
					caseNumber: this.problemDetail.problemNo,
					linkedStatus: this.problemDetail.linkedStatus,
				}),
			);

			this.store.dispatch(new CreatingCodeCase(true));
		}
	}

	createPermit() {
		this.store.dispatch(
			new AddPermit({
				caseNumber: this.problemDetail.problemNo,
				permitType: 'Tree Permit',
				linkedStatus: this.problemDetail.linkedStatus,
			}),
		);
		this.store.dispatch(new CreatingCodeCase(true));
	}

	filterProblemTypes(groupId?: number, formGroup?: UntypedFormGroup) {
		let form = this.reassignForm;
		if (formGroup) form = formGroup;

		if (!groupId) {
			groupId = this.problemDetail.group_RefId;
		}
		this.newCaseMenu$.pipe(delay(200), takeUntil(this.ngUnsubscribe)).subscribe((m) => {
			if (m.length > 0 && groupId > 0) {
				const menuConfig = m.filter((c) => c.group_RefId === groupId).map((mc) => mc.problemType_RefId);
				this.filteredProbTypes = this.allProblemTypes.filter((t) => menuConfig.indexOf(t.problemType_Id) > -1);
				// this.filteredProbTypes = [{active: true, description: "", problemType_Id: null, problemType_Name: "Please select"},
				// 	...tmpProbTypes
				// ]
				const currentType = form.get('problemType').value;
				if (currentType !== null) {
					if (this.filteredProbTypes.find((f) => f.problemType_Id === currentType.problemType_Id) === undefined) {
						form.get('problemType').setValue(null);
						setTimeout(() => {
							form.get('problemType').markAsUntouched();
							form.get('problemType').markAsPristine();
						}, 0);
					}
				}
			}
		});
	}

	buildCategories() {
		if (this.reassignForm.get('reassignToggle').value === false) {
			if (this.problemTypeMenu === undefined) {
				this.newCaseMenu$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((menuConfig) => {
					this.problemTypeMenu = buildMenu(menuConfig.filter((m) => m.showMenu));
				});
			}
			this.reassignForm.get('problemType').setValue(null);
			this.reassignForm.get('group').setValue(null);
			this.reassignForm.get('userName').clearValidators();
			this.reassignForm.get('userName').updateValueAndValidity();
			this.reassignForm.get('problemType').setValidators([Validators.required]);
			this.reassignForm.get('problemType').updateValueAndValidity();
		} else {
			// reassign user
			this.reassignForm.get('userName').setValidators([Validators.required]);
			this.reassignForm.get('userName').updateValueAndValidity();
			this.reassignForm.get('problemType').clearValidators();
			this.reassignForm.get('problemType').updateValueAndValidity();
		}
	}

	nextStep(pt: number, groupId: number) {
		console.log('problem type: ' + this.problemTypeMenu);
		const grp = this.groupList.filter((g) => g.group_Id === groupId);
		const probType = this.allProblemTypes.filter((p) => p.problemType_Id === pt);
		this.reassignForm.get('group').setValue(grp[0]);
		this.reassignForm.get('problemType').setValue(probType[0]);
		this.setDefaultUser();
	}

	nextOrMenu(menuTwo: any) {
		this.message = '';
		// tslint:disable-next-line: max-line-length
		const menuItems = this.menuConfig.filter(
			(m: { menuTwo: string; menuOne: string }) => m.menuTwo === menuTwo && m.menuOne === this.selectedMenuOne,
		);
		if (menuItems.length === 1 && menuItems[0].menuThree.length === 0) {
			if (menuItems[0].message !== '') {
				this.message = menuItems[0].message;
			} else {
				this.nextStep(menuItems[0].problemType_RefId, menuItems[0].group_RefId);
			}
		} else {
			this.menuTwoClick(menuTwo);
		}
	}

	menuThreeNextStep(menuThree: string) {
		const item = this.menuConfig.filter(
			(m: { menuThree: string; menuTwo: string; menuOne: string }) =>
				m.menuThree === menuThree && m.menuTwo === this.selectedMenuTwo && m.menuOne === this.selectedMenuOne,
		);
		if (item[0].problemType_RefId !== null) {
			this.nextStep(item[0].problemType_RefId, item[0].group_RefId);
		} else {
			this.message = item[0].message;
			document.querySelector('#modalTop').scrollIntoView(true);
		}
	}

	menuOneClick(val: string) {
		this.message = '';
		this.selectedMenuTwo = '';
		this.reassignForm.get('problemType').setValue(null);
		this.reassignForm.get('group').setValue(null);
		if (this.selectedMenuOne === val) {
			this.selectedMenuOne = '';
		} else {
			this.selectedMenuOne = val;
		}
		if (val === 'Noise') {
			const pt = this.menuConfig.filter((m) => m.menuOne === val);
			this.nextStep(pt[0].problemType_RefId, pt[0].group_RefId);
		}
	}

	menuTwoClick(val: any) {
		if (this.selectedMenuTwo === val.item) {
			this.selectedMenuTwo = '';
		} else {
			this.selectedMenuTwo = val.item;
			if (val.menuThree === null) {
				const grpId = this.menuConfig.filter((m) => m.menuTwo === val.item);
				const grp = this.groupList.filter((g) => g.group_Id === grpId[0].group_RefId);
				this.reassignForm.get('group').setValue(grp[0]);

				const probType = this.menuConfig.filter((m) => m.menuTwo === val.item);
				const pt = this.allProblemTypes.filter((p) => p.problemType_Id === probType[0].problemType_RefId);
				this.reassignForm.get('problemType').setValue(pt[0]);
			}
		}
		this.setDefaultUser();
		// console.log(this.selectedMenuTwo);
	}

	getProblemTypeName(typeId: number) {
		if (this.allProblemTypes !== undefined) {
			return this.allProblemTypes.filter((p) => p.problemType_Id === typeId)[0].problemType_Name;
		} else {
			return 'Loading...';
		}
	}

	getProblemSubTypeName(typeId: number) {
		if (this.filteredProblemSubTypes.length > 0) {
			return this.filteredProblemSubTypes.filter((p) => p.problemSubType_Id === typeId)[0]?.problemSubType_Name || '';
		}
	}

	mapGroupUsers() {
		const newUsers: any[] = [];
		if (this.groupedMappedUsers.length === 0) {
			const tempArr: { groupName: string; userFullName: string; userId: number | null; roleId: number | null }[] = [];
			this.menuOption.allUsersList.map((u) => {
				const grpRefs = this.menuOption.groupUser.filter((g) => g.user_RefId === u.user_Id);
				if (grpRefs !== undefined) {
					grpRefs.map((grpRef) => {
						const grp = this.groupList.find((gl) => gl.group_Id === (grpRef.group_RefId === null ? 0 : grpRef.group_RefId));

						const newObj = {
							groupId: grp.group_Id,
							groupName: grp.name,
							user: {
								...u,
								name: `${u.firstName} ${u.lastName}`.trim(),
							},
							name: u.firstName + ' ' + u.lastName,
							user_Id: u.user_Id,
						};

						return newUsers.push(newObj);
					});
				}
			});

			this.menuOption.problemRoleList.map((r) => {
				const grp = this.groupList.find((gl) => gl.group_Id === r.group_RefId);
				const newObj = {
					groupId: grp.group_Id,
					groupName: grp.name,
					user: r,
					name: r.name,
					role_Id: r.role_Id,
				};
				return newUsers.push(newObj);
			});

			this.mappedUsers = newUsers.sort((a, b) => a.groupId - b.groupId || a.name.localeCompare(b.name));
			//  console.log(this.mappedUsers);

			this.groupList.forEach((g) => {
				const grpUsers = this.mappedUsers.filter((usr) => usr.groupName === g.name);
				this.groupedMappedUsers.push({
					group: g.name,
					users: grpUsers.filter((u) => u.user.active === true),
				});
			});
			//  console.log(this.groupedMappedUsers);
		}
	}

	setDefaultUser(formGroup?: UntypedFormGroup) {
		let form = formGroup ? formGroup : this.reassignForm;
		form.get('userName').setValue(null);

		this.showAssignChange = false;
		const probType = form.get('problemType').value;
		const probGroup = form.get('group').value;
		let user;
		if (probType !== null && probGroup !== null) {
			const probAssign = this.problemAssignments.filter(
				(m) => m.group_RefId === probGroup.group_Id && m.problemType_RefId === probType.problemType_Id,
			);

			if (probAssign.length === 1) {
				if (probAssign[0].user_RefId !== null) {
					user = this.mappedUsers.find((u) => u.groupId === probGroup.group_Id && u.user_Id === probAssign[0].user_RefId);
					// if (!user) {
					//   // Look for the user in any group.
					//   user = this.mappedUsers.find(u => u.userId === probAssign[0].user_RefId);
					// }
				} else {
					user = this.mappedUsers.find((u) => u.role_Id === probAssign[0].role_RefId);
				}

				if (user !== undefined) {
					if (user.user.active) {
						form.get('userName').setValue(user.user);
					}

					// else {
					// 	form.get('userName').setValue(null);
					// }
				}
			} else if (probAssign.length > 1) {
				// look up GIS

				probAssign.forEach((pa) => {
					this.searchCoordinate.searchLocation.forEach((location) => {
						let userId: number;
						let roleId: number;
						if (pa.locationType === location.locationType && pa.location === location.location) {
							userId = pa.user_RefId;
							roleId = pa.role_RefId;

							if (userId !== null && userId !== undefined) {
								user = this.mappedUsers.find((u) => u.groupId === probGroup.group_Id && u.user_Id === userId);
								if (!user) {
									// Look for the user in any group.
									user = this.mappedUsers.find((u) => u.user_Id === userId);
								}

								form.get('userName').setValue(user.user);
								return;
							} else if (roleId !== null && roleId !== undefined) {
								user = this.mappedUsers.find((u) => u.role_Id === roleId);
								form.get('userName').setValue(user.user);
								return;
							}
						}
					});
				});
			}
		}

		if (user !== undefined && !formGroup) {
			const userFullName = user.user.firstName === undefined ? user.user.name : user.user.firstName + ' ' + user.user.lastName;
			this.assignChangeMsg = 'The problem will update to ' + probType.problemType_Name + ' and be assigned to ' + userFullName;
			this.showAssignChange = true;
		}
	}

	changeUser() {
		const probType = this.reassignForm.get('problemType').value;
		const usr = this.reassignForm.get('userName').value?.user;
		if (usr) {
			const userFullName = usr.firstName === undefined ? usr.name : usr.firstName + ' ' + usr.lastName;
			this.assignChangeMsg = 'The problem will update to ' + probType.problemType_Name + ' and be assigned to ' + userFullName;
		}
	}

	printDetails() {
		window.print();
	}

	openDuplicateModal() {
		const defaultGroup = this.groupList.filter((g) => g.group_Id === this.problemDetail.group_RefId);
		const probType = this.allProblemTypes.filter((p) => p.problemType_Id === this.problemDetail.problemType_RefId);
		this.filterProblemTypes(defaultGroup[0].group_Id, this.duplicateCaseForm);

		this.duplicateCaseForm.get('group').setValue(defaultGroup[0]);
		this.duplicateCaseForm.get('problemType').setValue(probType[0]);

		const tempRole = this.getAssignedToName();
		this.duplicateCaseForm.get('userName').setValue(tempRole);
		this.groupUsers = this.mappedUsers.filter((mu) => mu.groupId === defaultGroup[0].group_Id && mu.user.active === true);

		this.open(this.duplicateCaseModal);
	}

	openZipFilesModal() {
		this.open(this.zipFilesModal);
	}

	closeZipFilesModal() {
		this.close();
		this.hasZipFilesError = false;
		this.shouldZipAllFiles = false;
	}

	onZipFiles() {
		let includingAttachments = (document.getElementById('radio_addAttachments') as any).checked;
		let ignoringAttachments = (document.getElementById('radio_ignoreAttachments') as any).checked;
		this.hasZipFilesError = !includingAttachments && !ignoringAttachments;

		if (!this.hasZipFilesError) {
			this.close();
			this.shouldZipAllFiles = includingAttachments;
			setTimeout(() => this.saveAsPDF(), 1000);
		}
	}

	async saveAsPDF() {
		this.store.dispatch(new CreatingCodeCase(true));
		const data = document.getElementById('top-details');
		const svgElements = document.body.querySelectorAll('svg.svg-inline--fa');

		// Need to specify the boundary of SVG in order for html2canvas to capture map markers (fontawesome).
		svgElements.forEach((item) => {
			item.setAttribute('width', item.getBoundingClientRect().width.toString());
			item.setAttribute('height', item.getBoundingClientRect().height.toString());
		});

		html2canvas(data, { useCORS: true, allowTaint: false, removeContainer: false }).then(async (canvas) => {
			const imgData = canvas.toDataURL('image/jpeg', 0.5);

			// Few necessary setting options
			const imgWidth = 208;
			const pageHeight = 295;
			const imgHeight = (canvas.height * imgWidth) / canvas.width;
			let position = 10;

			// this.handleCanvasCleanup();

			const doc = new jsPDF('p', 'mm');
			let heightLeft = imgHeight;
			doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);

			heightLeft -= pageHeight;
			while (heightLeft >= 0) {
				position = heightLeft + 10 - imgHeight;
				doc.addPage();
				doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);

				heightLeft -= pageHeight;
			}

			const blobPDF = new Blob([doc.output('blob')], { type: 'application/pdf' });
			const payload: UploadAttachmentsPayload = {
				caseNo: this.problemNo,
				attachment: { files: blobPDF, state: 'blob' },
				description: 'Problem Details Screenshot',
				modal: null,
				postUploadActions: [],
			};

			if (this.shouldZipAllFiles) {
				let edocDocuments = this.attachments.filter((att) => att.docNumber > 0);
				let azureDocuments = this.attachments.filter((att) => att.docNumber === 0);

				let edocNums = edocDocuments.map((att) => att.docNumber);
				let azureDetails = azureDocuments.map((att) => att.description);

				let zip = new JSZip();
				zip.file(`${this.problemNo} Case Summary.pdf`, blobPDF);
				let fileNamesUsed: string[] = [];

				for (let i = 0; i < edocNums.length; i++) {
					let blob = await this.problemsService
						.downloadEdocsFile(edocNums[i])
						.pipe(first())
						.toPromise();
					let fileBlob = new Blob([blob], { type: blob.type });
					this.addFileToZip(fileBlob, zip, edocDocuments[i], fileNamesUsed);
				}

				for (let i = 0; i < azureDetails.length; i++) {
					let blob = await this.problemsService
						.downloadAzureFile(azureDetails[i])
						.pipe(first())
						.toPromise();
					let fileBlob = new Blob([blob], { type: blob.type });
					this.addFileToZip(fileBlob, zip, azureDocuments[i], fileNamesUsed);
				}

				zip.generateAsync({ type: 'blob' }).then((zipBlob) => {
					saveAs(zipBlob, `${this.problemNo} summary and documents`);
				});
			} else {
				let fileUrl = URL.createObjectURL(blobPDF);
				let link = document.createElement('a');

				window.open(fileUrl);
				link.download = 'Export.pdf';
				link.href = fileUrl;
				link.click();

				URL.revokeObjectURL(fileUrl);
				link.remove();
			}

			this.store.dispatch(new UploadAttachments(payload));
			this.shouldZipAllFiles = false;
		});
	}

	addFileToZip(blob: Blob, zip: JSZip, document: Attachment, fileNamesUsed: string[]) {
		// let fileBlob = new Blob([blob], { type: 'application/octet-stream' });
		let fileName = document.attachment_Name;
		let fileType = document.fileType.toLowerCase();

		if (!fileNamesUsed.includes(fileName)) fileNamesUsed.push(fileName);
		else {
			let numOccurrances = fileNamesUsed.filter((name) => name.includes(fileName)).length;
			fileName = `${fileName}_${numOccurrances}`;
			fileNamesUsed.push(fileName);
		}

		zip.file(`${fileName}.${fileType}`, blob);
	}

	// handleCanvasCleanup() {
	//   document.dispatchEvent(new Event('destroyMap'));
	//   document.dispatchEvent(new Event('destroyDocumentClone'));
	//   document.querySelectorAll('.html2canvas-container').forEach((el: any) => {
	//     let iframe = el.contentWindow;
	//     if (el) {
	//       var removeChilds = (node: HTMLElement) => {
	//         var last;
	//         while (last = node.lastChild) node.removeChild(last);
	//       };

	//       removeChilds(iframe.document);
	//       el.src = 'about:blank';
	//       iframe.document.write('');
	//       iframe.document.clear();
	//       iframe.close();
	//       el.remove();

	//       iframe = null;
	//       el = null;
	//     }
	//   });
	// }

	tagAssetGT() {
		const lat = this.problemDetail.latLng.lat;
		const lng = this.problemDetail.latLng.lng;
		window.location.href = environment.geotoolsUrl + 'rap;lat=' + lat + ';lng=' + lng + ';problemNo=' + this.problemDetail.problemNo;
	}

	openStreetView() {
		const lat = this.problemDetail.latLng.lat;
		const lng = this.problemDetail.latLng.lng;

		window.open('http://maps.google.com/?cbll=' + lat + ', ' + lng + '&cbp=12,20.09,,0,5&layer=c', '_blank');
	}
}
